// Transcrit par esbuild depuis packages/reasoner/src/kernel-python.ts (moteur gelé) : ne pas modifier à la main.
// packages/reasoner/src/kernel/exact.ts
var MAX_POW = 4096;
function babs(a) {
  return a < 0n ? -a : a;
}
function gcd(a, b) {
  a = babs(a);
  b = babs(b);
  while (b !== 0n) [a, b] = [b, a % b];
  return a;
}
function toBig(v) {
  if (typeof v === 'bigint') return v;
  if (!Number.isSafeInteger(v)) throw new RangeError(`entier attendu : ${v}`);
  return BigInt(v);
}
function rat(n, d = 1n) {
  let nn = toBig(n);
  let dd = toBig(d);
  if (dd === 0n) throw new RangeError('d\xE9nominateur nul');
  if (dd < 0n) {
    nn = -nn;
    dd = -dd;
  }
  const g = gcd(nn, dd) || 1n;
  return { n: nn / g, d: dd / g };
}
var ZERO = rat(0);
var ONE = rat(1);
function add(a, b) {
  return rat(a.n * b.d + b.n * a.d, a.d * b.d);
}
function sub(a, b) {
  return rat(a.n * b.d - b.n * a.d, a.d * b.d);
}
function mul(a, b) {
  return rat(a.n * b.n, a.d * b.d);
}
function div(a, b) {
  if (b.n === 0n) return null;
  return rat(a.n * b.d, a.d * b.n);
}
function neg(a) {
  return { n: -a.n, d: a.d };
}
function abs(a) {
  return a.n < 0n ? neg(a) : a;
}
function sign(a) {
  return a.n === 0n ? 0 : a.n < 0n ? -1 : 1;
}
function cmp(a, b) {
  const x = a.n * b.d - b.n * a.d;
  return x === 0n ? 0 : x < 0n ? -1 : 1;
}
function eq(a, b) {
  return a.n === b.n && a.d === b.d;
}
function isInteger(a) {
  return a.d === 1n;
}
function pow(a, k) {
  if (!Number.isInteger(k) || Math.abs(k) > MAX_POW) return null;
  if (k < 0) {
    if (a.n === 0n) return null;
    return pow(rat(a.d, a.n), -k);
  }
  const e = BigInt(k);
  return rat(a.n ** e, a.d ** e);
}
function ratToText(a) {
  return a.d === 1n ? a.n.toString() : `${a.n}/${a.d}`;
}
var DECIMAL_RE = /^([+\-−]?)(\d{1,40})(?:[.,](\d{1,40}))?$/;
function parseDecimal(text) {
  const m = DECIMAL_RE.exec(text.trim());
  if (!m) return null;
  const frac = m[3] ?? '';
  const n = BigInt(m[2] + frac);
  const r = rat(n, 10n ** BigInt(frac.length));
  return m[1] === '-' || m[1] === '\u2212' ? neg(r) : r;
}
function fromRat(q) {
  return { coef: q, rad: 1n };
}
function radCmpRat(a, q) {
  if (a.rad === 1n || a.coef.n === 0n) return cmp(a.coef, q);
  const sa = sign(a.coef);
  const sq = sign(q);
  if (sa !== sq) return sa > sq ? 1 : -1;
  const left = mul(mul(a.coef, a.coef), rat(a.rad));
  const right = mul(q, q);
  const c = cmp(left, right);
  return sa > 0 ? c : -c;
}
function isRoundingOf(value, approx, places) {
  if (!Number.isInteger(places) || places < 0 || places > 30) return false;
  const half = rat(1n, 2n * 10n ** BigInt(places));
  return radCmpRat(value, sub(approx, half)) >= 0 && radCmpRat(value, add(approx, half)) <= 0;
}

// packages/reasoner/src/kernel/python/errors.ts
var PyError = class extends Error {
  constructor(code, message, line) {
    super(message);
    this.code = code;
    this.line = line;
    this.name = 'PyError';
  }
  code;
  line;
};

// packages/reasoner/src/kernel/python/lexer.ts
var OPS = [
  '**=',
  '//=',
  '**',
  '//',
  '==',
  '!=',
  '<=',
  '>=',
  '+=',
  '-=',
  '*=',
  '/=',
  '%=',
  '->',
  '+',
  '-',
  '*',
  '/',
  '%',
  '<',
  '>',
  '=',
  '(',
  ')',
  '[',
  ']',
  '{',
  '}',
  ',',
  ':',
  '.',
  ';',
];
var MAX_SOURCE_LENGTH = 4e3;
function tokenize(src) {
  if (src.length > MAX_SOURCE_LENGTH) throw new PyError('syntax', 'Programme trop long.', 1);
  const out = [];
  const lines = src.replace(/\r\n?/g, '\n').split('\n');
  const indents = [0];
  let depth = 0;
  for (let li = 0; li < lines.length; li++) {
    const raw = lines[li];
    const lineNo = li + 1;
    let i = 0;
    if (depth === 0) {
      let col = 0;
      while (i < raw.length && (raw[i] === ' ' || raw[i] === '	')) {
        col += raw[i] === '	' ? 4 : 1;
        i++;
      }
      const rest = raw.slice(i);
      if (!rest.trim() || rest.trimStart().startsWith('#')) continue;
      const top = indents[indents.length - 1];
      if (col > top) {
        indents.push(col);
        out.push({ t: 'indent', v: '', line: lineNo });
      } else if (col < top) {
        while (indents[indents.length - 1] > col) {
          indents.pop();
          out.push({ t: 'dedent', v: '', line: lineNo });
        }
        if (indents[indents.length - 1] !== col)
          throw new PyError('syntax', 'Indentation incoh\xE9rente.', lineNo);
      }
    }
    while (i < raw.length) {
      const c = raw[i];
      if (c === ' ' || c === '	') {
        i++;
        continue;
      }
      if (c === '#') break;
      if (c === '\\' && i === raw.length - 1) {
        i++;
        continue;
      }
      if (/[A-Za-z_À-ɏ]/.test(c)) {
        let j = i + 1;
        while (j < raw.length && /[A-Za-z0-9_À-ɏ]/.test(raw[j])) j++;
        out.push({ t: 'name', v: raw.slice(i, j), line: lineNo });
        i = j;
        continue;
      }
      if (/[0-9]/.test(c) || (c === '.' && /[0-9]/.test(raw[i + 1] ?? ''))) {
        const m = /^(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?/.exec(raw.slice(i));
        if (/[A-Za-z_]/.test(raw[i + m[0].length] ?? ''))
          throw new PyError('syntax', 'Nombre mal \xE9crit.', lineNo);
        out.push({ t: 'num', v: m[0], line: lineNo });
        i += m[0].length;
        continue;
      }
      if (c === '"' || c === "'") {
        let j = i + 1;
        let s = '';
        while (j < raw.length && raw[j] !== c) {
          if (raw[j] === '\\' && j + 1 < raw.length) {
            const e = raw[j + 1];
            s += e === 'n' ? '\n' : e === 't' ? '	' : e;
            j += 2;
          } else s += raw[j++];
        }
        if (j >= raw.length)
          throw new PyError('syntax', 'Cha\xEEne de caract\xE8res non ferm\xE9e.', lineNo);
        out.push({ t: 'str', v: s, line: lineNo });
        i = j + 1;
        continue;
      }
      const op = OPS.find((o) => raw.startsWith(o, i));
      if (!op) throw new PyError('syntax', `Caract\xE8re inattendu \xAB ${c} \xBB.`, lineNo);
      if (op === '(' || op === '[' || op === '{') depth++;
      if (op === ')' || op === ']' || op === '}') depth = Math.max(0, depth - 1);
      out.push({ t: 'op', v: op, line: lineNo });
      i += op.length;
    }
    if (depth === 0 && out.length && out[out.length - 1].t !== 'newline')
      out.push({ t: 'newline', v: '', line: lineNo });
  }
  if (depth > 0) throw new PyError('syntax', 'Parenth\xE8se non ferm\xE9e.', lines.length);
  const last = lines.length;
  if (out.length && out[out.length - 1].t !== 'newline')
    out.push({ t: 'newline', v: '', line: last });
  while (indents.length > 1) {
    indents.pop();
    out.push({ t: 'dedent', v: '', line: last });
  }
  out.push({ t: 'eof', v: '', line: last });
  return out;
}

// packages/reasoner/src/kernel/python/parser.ts
var KEYWORDS = /* @__PURE__ */ new Set([
  'if',
  'elif',
  'else',
  'while',
  'for',
  'in',
  'def',
  'return',
  'and',
  'or',
  'not',
  'pass',
  'break',
  'continue',
  'import',
  'from',
  'as',
  'is',
  'lambda',
  'class',
  'try',
  'except',
  'with',
  'global',
  'nonlocal',
  'yield',
  'del',
  'assert',
  'raise',
  'True',
  'False',
  'None',
]);
var UNSUPPORTED = /* @__PURE__ */ new Set([
  'lambda',
  'class',
  'try',
  'except',
  'with',
  'global',
  'nonlocal',
  'yield',
  'del',
  'assert',
  'raise',
  'is',
  'as',
]);
var AUG = {
  '+=': '+',
  '-=': '-',
  '*=': '*',
  '/=': '/',
  '//=': '//',
  '%=': '%',
  '**=': '**',
};
var Parser = class {
  constructor(toks) {
    this.toks = toks;
  }
  toks;
  i = 0;
  get tok() {
    return this.toks[this.i];
  }
  kind() {
    return this.toks[this.i].t;
  }
  peek(n = 1) {
    return this.toks[Math.min(this.i + n, this.toks.length - 1)];
  }
  isOp(v) {
    return this.tok.t === 'op' && this.tok.v === v;
  }
  isKw(v) {
    return this.tok.t === 'name' && this.tok.v === v;
  }
  fail(msg, line = this.tok.line) {
    throw new PyError('syntax', msg, line);
  }
  expectOp(v) {
    if (!this.isOp(v)) this.fail(`\xAB ${v} \xBB attendu.`);
    return this.toks[this.i++];
  }
  expectKw(v) {
    if (!this.isKw(v)) this.fail(`\xAB ${v} \xBB attendu.`);
    this.i++;
  }
  expectName() {
    const t = this.tok;
    if (t.t !== 'name' || KEYWORDS.has(t.v)) this.fail('Nom attendu.');
    this.i++;
    return t;
  }
  module() {
    const body = [];
    while (this.tok.t !== 'eof') {
      if (this.tok.t === 'newline') {
        this.i++;
        continue;
      }
      if (this.tok.t === 'indent') this.fail('Indentation inattendue.');
      body.push(...this.statement());
    }
    return { body };
  }
  statement() {
    const t = this.tok;
    if (t.t === 'name' && UNSUPPORTED.has(t.v))
      throw new PyError('unsupported', `\xAB ${t.v} \xBB n\u2019est pas pris en charge.`, t.line);
    if (this.isKw('if')) return [this.ifStmt()];
    if (this.isKw('while')) return [this.whileStmt()];
    if (this.isKw('for')) return [this.forStmt()];
    if (this.isKw('def')) return [this.defStmt()];
    return this.simpleLine();
  }
  block() {
    this.expectOp(':');
    if (this.tok.t !== 'newline') return this.simpleLine();
    this.i++;
    if (this.toks[this.i].t !== 'indent') this.fail('Bloc indent\xE9 attendu.');
    this.i++;
    const body = [];
    while (this.kind() !== 'dedent' && this.kind() !== 'eof') {
      if (this.kind() === 'newline') {
        this.i++;
        continue;
      }
      body.push(...this.statement());
    }
    if (this.kind() === 'dedent') this.i++;
    if (!body.length) this.fail('Bloc vide.');
    return body;
  }
  ifStmt() {
    const line = this.tok.line;
    this.i++;
    const test = this.expr();
    const body = this.block();
    let orelse = [];
    if (this.isKw('elif')) {
      const s = this.ifStmt();
      orelse = [{ ...s, elif: true }];
    } else if (this.isKw('else')) {
      this.i++;
      orelse = this.block();
    }
    return { k: 'if', test, body, orelse, line };
  }
  whileStmt() {
    const line = this.tok.line;
    this.i++;
    const test = this.expr();
    const body = this.block();
    if (this.isKw('else'))
      throw new PyError(
        'unsupported',
        '\xAB while \u2026 else \xBB n\u2019est pas pris en charge.',
        this.tok.line,
      );
    return { k: 'while', test, body, line };
  }
  forStmt() {
    const line = this.tok.line;
    this.i++;
    const target = this.targetList();
    this.expectKw('in');
    const iter = this.exprList();
    const body = this.block();
    if (this.isKw('else'))
      throw new PyError(
        'unsupported',
        '\xAB for \u2026 else \xBB n\u2019est pas pris en charge.',
        this.tok.line,
      );
    return { k: 'for', target, iter, body, line };
  }
  defStmt() {
    const line = this.tok.line;
    this.i++;
    const name = this.expectName().v;
    this.expectOp('(');
    const params = [];
    while (!this.isOp(')')) {
      params.push(this.expectName().v);
      if (this.isOp(':'))
        throw new PyError(
          'unsupported',
          'Les annotations de type ne sont pas prises en charge.',
          this.tok.line,
        );
      if (this.isOp('='))
        throw new PyError(
          'unsupported',
          'Les valeurs par d\xE9faut ne sont pas prises en charge.',
          this.tok.line,
        );
      if (!this.isOp(')')) this.expectOp(',');
    }
    this.i++;
    if (this.isOp('->'))
      throw new PyError(
        'unsupported',
        'Les annotations de type ne sont pas prises en charge.',
        this.tok.line,
      );
    if (new Set(params).size !== params.length) this.fail('Param\xE8tre en double.', line);
    const body = this.block();
    return { k: 'def', name, params, body, line };
  }
  /** instructions simples d'une ligne, séparées par « ; » */
  simpleLine() {
    const out = [this.small()];
    while (this.isOp(';')) {
      this.i++;
      if (this.tok.t === 'newline') break;
      out.push(this.small());
    }
    if (this.tok.t !== 'newline') this.fail('Fin de ligne attendue.');
    this.i++;
    return out;
  }
  small() {
    const t = this.tok;
    const line = t.line;
    if (t.t === 'name' && UNSUPPORTED.has(t.v))
      throw new PyError('unsupported', `\xAB ${t.v} \xBB n\u2019est pas pris en charge.`, line);
    if (this.isKw('pass')) {
      this.i++;
      return { k: 'pass', line };
    }
    if (this.isKw('break')) {
      this.i++;
      return { k: 'break', line };
    }
    if (this.isKw('continue')) {
      this.i++;
      return { k: 'continue', line };
    }
    if (this.isKw('return')) {
      this.i++;
      if (this.tok.t === 'newline' || this.isOp(';')) return { k: 'return', value: null, line };
      return { k: 'return', value: this.exprList(), line };
    }
    if (this.isKw('import')) {
      this.i++;
      const names = [this.expectName().v];
      while (this.isOp(',')) {
        this.i++;
        names.push(this.expectName().v);
      }
      return { k: 'import', names, from: null, line };
    }
    if (this.isKw('from')) {
      this.i++;
      const mod = this.expectName().v;
      this.expectKw('import');
      const names = [];
      if (this.isOp('*')) {
        this.i++;
        names.push('*');
      } else {
        names.push(this.expectName().v);
        while (this.isOp(',')) {
          this.i++;
          names.push(this.expectName().v);
        }
      }
      return { k: 'import', names, from: mod, line };
    }
    const first = this.exprList();
    if (this.tok.t === 'op' && AUG[this.tok.v]) {
      const op = AUG[this.tok.v];
      this.i++;
      const target = toTarget(first);
      if (target.k === 'tuple')
        this.fail('Affectation augment\xE9e sur plusieurs variables.', line);
      return { k: 'aug', target, op, value: this.expr(), line };
    }
    if (this.isOp('=')) {
      const targets = [toTarget(first)];
      let value = first;
      while (this.isOp('=')) {
        this.i++;
        value = this.exprList();
        if (this.isOp('=')) targets.push(toTarget(value));
      }
      return { k: 'assign', targets, value, line };
    }
    return { k: 'expr', e: first, line };
  }
  targetList() {
    const line = this.tok.line;
    const items = [toTarget(this.primaryOrParen())];
    let tuple = false;
    while (this.isOp(',')) {
      tuple = true;
      this.i++;
      if (this.isKw('in')) break;
      items.push(toTarget(this.primaryOrParen()));
    }
    return tuple ? { k: 'tuple', items, line } : items[0];
  }
  primaryOrParen() {
    return this.primary();
  }
  /** suite d'expressions séparées par des virgules (un tuple s'il y en a plusieurs) */
  exprList() {
    const line = this.tok.line;
    const first = this.expr();
    if (!this.isOp(',')) return first;
    const items = [first];
    while (this.isOp(',')) {
      this.i++;
      if (this.endsList()) break;
      items.push(this.expr());
    }
    return { k: 'tuple', items, line };
  }
  endsList() {
    const t = this.tok;
    return (
      t.t === 'newline' ||
      (t.t === 'op' && [')', ']', '=', ';', ':'].includes(t.v)) ||
      (t.t === 'op' && !!AUG[t.v])
    );
  }
  expr() {
    const line = this.tok.line;
    const body = this.orTest();
    if (this.isKw('if')) {
      this.i++;
      const test = this.orTest();
      this.expectKw('else');
      const orelse = this.expr();
      return { k: 'ifexp', test, body, orelse, line };
    }
    return body;
  }
  orTest() {
    let l = this.andTest();
    while (this.isKw('or')) {
      const line = this.tok.line;
      this.i++;
      l = { k: 'bool', op: 'or', l, r: this.andTest(), line };
    }
    return l;
  }
  andTest() {
    let l = this.notTest();
    while (this.isKw('and')) {
      const line = this.tok.line;
      this.i++;
      l = { k: 'bool', op: 'and', l, r: this.notTest(), line };
    }
    return l;
  }
  notTest() {
    if (this.isKw('not')) {
      const line = this.tok.line;
      this.i++;
      return { k: 'unary', op: 'not', e: this.notTest(), line };
    }
    return this.comparison();
  }
  cmpOp() {
    const t = this.tok;
    if (t.t === 'op' && ['<', '>', '<=', '>=', '==', '!='].includes(t.v)) return t.v;
    if (this.isKw('in')) return 'in';
    if (this.isKw('not') && this.peek().t === 'name' && this.peek().v === 'in') return 'not in';
    if (this.isKw('is'))
      throw new PyError('unsupported', '\xAB is \xBB n\u2019est pas pris en charge.', t.line);
    return null;
  }
  comparison() {
    const line = this.tok.line;
    const first = this.arith();
    const ops = [];
    const rest = [];
    for (let op = this.cmpOp(); op; op = this.cmpOp()) {
      this.i += op === 'not in' ? 2 : 1;
      ops.push(op);
      rest.push(this.arith());
    }
    return ops.length ? { k: 'compare', first, ops, rest, line } : first;
  }
  arith() {
    let l = this.term();
    while (this.isOp('+') || this.isOp('-')) {
      const t = this.toks[this.i++];
      l = { k: 'bin', op: t.v, l, r: this.term(), line: t.line };
    }
    return l;
  }
  term() {
    let l = this.factor();
    while (this.isOp('*') || this.isOp('/') || this.isOp('//') || this.isOp('%')) {
      const t = this.toks[this.i++];
      l = { k: 'bin', op: t.v, l, r: this.factor(), line: t.line };
    }
    return l;
  }
  factor() {
    if (this.isOp('-') || this.isOp('+')) {
      const t = this.toks[this.i++];
      return { k: 'unary', op: t.v, e: this.factor(), line: t.line };
    }
    return this.power();
  }
  power() {
    const base = this.primary();
    if (this.isOp('**')) {
      const t = this.toks[this.i++];
      return { k: 'bin', op: '**', l: base, r: this.factor(), line: t.line };
    }
    return base;
  }
  primary() {
    let e = this.atom();
    for (;;) {
      if (this.isOp('(')) {
        const line = this.tok.line;
        this.i++;
        const args = [];
        while (!this.isOp(')')) {
          if (this.tok.t === 'name' && this.peek().t === 'op' && this.peek().v === '=')
            throw new PyError(
              'unsupported',
              'Les arguments nomm\xE9s ne sont pas pris en charge.',
              this.tok.line,
            );
          args.push(this.expr());
          if (!this.isOp(')')) this.expectOp(',');
        }
        this.i++;
        e = { k: 'call', f: e, args, line };
      } else if (this.isOp('[')) {
        const line = this.tok.line;
        this.i++;
        let lo = null;
        if (!this.isOp(':')) lo = this.expr();
        if (this.isOp(':')) {
          this.i++;
          const hi = this.isOp(']') || this.isOp(':') ? null : this.expr();
          let step = null;
          if (this.isOp(':')) {
            this.i++;
            step = this.isOp(']') ? null : this.expr();
          }
          this.expectOp(']');
          e = { k: 'slice', e, lo, hi, step, line };
        } else {
          this.expectOp(']');
          e = { k: 'index', e, i: lo, line };
        }
      } else if (this.isOp('.')) {
        const line = this.tok.line;
        this.i++;
        e = { k: 'attr', e, name: this.expectName().v, line };
      } else return e;
    }
  }
  atom() {
    const t = this.tok;
    const line = t.line;
    if (t.t === 'num') {
      this.i++;
      return { k: 'num', text: t.v, line };
    }
    if (t.t === 'str') {
      this.i++;
      let v = t.v;
      while (this.tok.t === 'str') v += this.toks[this.i++].v;
      return { k: 'str', v, line };
    }
    if (t.t === 'name') {
      if (t.v === 'True' || t.v === 'False' || t.v === 'None') {
        this.i++;
        return { k: 'const', v: t.v, line };
      }
      if (UNSUPPORTED.has(t.v))
        throw new PyError('unsupported', `\xAB ${t.v} \xBB n\u2019est pas pris en charge.`, line);
      if (KEYWORDS.has(t.v)) this.fail(`\xAB ${t.v} \xBB inattendu.`);
      this.i++;
      return { k: 'name', id: t.v, line };
    }
    if (this.isOp('(')) {
      this.i++;
      if (this.isOp(')')) {
        this.i++;
        return { k: 'tuple', items: [], line };
      }
      const first = this.expr();
      if (this.isOp(')')) {
        this.i++;
        return first;
      }
      const items = [first];
      while (this.isOp(',')) {
        this.i++;
        if (this.isOp(')')) break;
        items.push(this.expr());
      }
      this.expectOp(')');
      return { k: 'tuple', items, line };
    }
    if (this.isOp('[')) {
      this.i++;
      const items = [];
      if (this.isOp(']')) {
        this.i++;
        return { k: 'list', items, line };
      }
      const first = this.expr();
      if (this.isKw('for')) {
        this.i++;
        const target = this.targetList();
        this.expectKw('in');
        const iter = this.orTest();
        let cond = null;
        if (this.isKw('if')) {
          this.i++;
          cond = this.orTest();
        }
        if (this.isKw('for'))
          throw new PyError('unsupported', 'Une seule boucle par compr\xE9hension.', this.tok.line);
        this.expectOp(']');
        return { k: 'comp', elt: first, target, iter, cond, line };
      }
      items.push(first);
      while (this.isOp(',')) {
        this.i++;
        if (this.isOp(']')) break;
        items.push(this.expr());
      }
      this.expectOp(']');
      return { k: 'list', items, line };
    }
    if (this.isOp('{'))
      throw new PyError('unsupported', 'Les dictionnaires ne sont pas pris en charge.', line);
    if (t.t === 'newline' || t.t === 'eof') this.fail('Expression incompl\xE8te.');
    this.fail(`\xAB ${t.v} \xBB inattendu.`);
  }
};
function toTarget(e) {
  if (e.k === 'name') return { k: 'name', id: e.id, line: e.line };
  if (e.k === 'tuple') return { k: 'tuple', items: e.items.map(toTarget), line: e.line };
  if (e.k === 'index') return { k: 'index', e: e.e, i: e.i, line: e.line };
  throw new PyError('syntax', 'On ne peut pas affecter une valeur \xE0 cette expression.', e.line);
}
function parseProgram(src) {
  return new Parser(tokenize(src)).module();
}
function parseExpression(src) {
  const p = new Parser(tokenize(src));
  const e = p.expr();
  return e;
}

// packages/reasoner/src/kernel/python/ast.ts
var isCompound = (s) => s.k === 'if' || s.k === 'while' || s.k === 'for' || s.k === 'def';

// packages/reasoner/src/kernel/python/mt.ts
var N = 624;
var M = 397;
var MATRIX_A = 2567483615;
var UPPER = 2147483648;
var LOWER = 2147483647;
var MersenneTwister = class {
  mt = new Uint32Array(N);
  mti = N + 1;
  constructor(seed = 0n) {
    this.seed(seed);
  }
  initGenrand(s) {
    const mt = this.mt;
    mt[0] = s >>> 0;
    for (let i = 1; i < N; i++) {
      const p = mt[i - 1];
      mt[i] = (Math.imul(1812433253, p ^ (p >>> 30)) + i) >>> 0;
    }
    this.mti = N;
  }
  initByArray(key) {
    const mt = this.mt;
    this.initGenrand(19650218);
    let i = 1;
    let j = 0;
    for (let k = Math.max(N, key.length); k > 0; k--) {
      const p = mt[i - 1];
      mt[i] = ((mt[i] ^ Math.imul(p ^ (p >>> 30), 1664525)) + key[j] + j) >>> 0;
      i++;
      j++;
      if (i >= N) {
        mt[0] = mt[N - 1];
        i = 1;
      }
      if (j >= key.length) j = 0;
    }
    for (let k = N - 1; k > 0; k--) {
      const p = mt[i - 1];
      mt[i] = ((mt[i] ^ Math.imul(p ^ (p >>> 30), 1566083941)) - i) >>> 0;
      i++;
      if (i >= N) {
        mt[0] = mt[N - 1];
        i = 1;
      }
    }
    mt[0] = 2147483648;
  }
  /** `random.seed(a)` pour un entier : la valeur absolue découpée en mots de 32 bits */
  seed(a) {
    let n = a < 0n ? -a : a;
    const key = [];
    while (n > 0n) {
      key.push(Number(n & 0xffffffffn));
      n >>= 32n;
    }
    if (!key.length) key.push(0);
    this.initByArray(key);
  }
  /** un mot de 32 bits */
  next32() {
    const mt = this.mt;
    if (this.mti >= N) {
      let kk = 0;
      let y2;
      for (; kk < N - M; kk++) {
        y2 = (mt[kk] & UPPER) | (mt[kk + 1] & LOWER);
        mt[kk] = mt[kk + M] ^ (y2 >>> 1) ^ (y2 & 1 ? MATRIX_A : 0);
      }
      for (; kk < N - 1; kk++) {
        y2 = (mt[kk] & UPPER) | (mt[kk + 1] & LOWER);
        mt[kk] = mt[kk + (M - N)] ^ (y2 >>> 1) ^ (y2 & 1 ? MATRIX_A : 0);
      }
      y2 = (mt[N - 1] & UPPER) | (mt[0] & LOWER);
      mt[N - 1] = mt[M - 1] ^ (y2 >>> 1) ^ (y2 & 1 ? MATRIX_A : 0);
      this.mti = 0;
    }
    let y = mt[this.mti++];
    y ^= y >>> 11;
    y ^= (y << 7) & 2636928640;
    y ^= (y << 15) & 4022730752;
    y ^= y >>> 18;
    return y >>> 0;
  }
  /** `random.random()` : un multiple de 2⁻⁵³ dans [0 ; 1[, sous forme de fraction exacte */
  random() {
    const a = BigInt(this.next32() >>> 5);
    const b = BigInt(this.next32() >>> 6);
    return { n: a * 67108864n + b, d: 9007199254740992n };
  }
  /** `getrandbits(k)` */
  getrandbits(k) {
    if (k <= 0) return 0n;
    if (k <= 32) return BigInt(this.next32() >>> (32 - k));
    let out = 0n;
    let shift = 0n;
    for (let left = k; left > 0; left -= 32) {
      let r = this.next32();
      if (left < 32) r >>>= 32 - left;
      out |= BigInt(r) << shift;
      shift += 32n;
    }
    return out;
  }
  /** `_randbelow(n)` : un entier de [0 ; n[ (rejet, comme CPython) */
  randbelow(n) {
    if (n <= 0n) return 0n;
    const k = n.toString(2).length;
    let r = this.getrandbits(k);
    while (r >= n) r = this.getrandbits(k);
    return r;
  }
};

// packages/reasoner/src/kernel/python/value.ts
var NONE = { t: 'none' };
var pyInt = (v) => ({ t: 'int', v: BigInt(v) });
var pyFloat = (v) => ({ t: 'float', v });
var pyBool = (v) => ({ t: 'bool', v });
var isNumeric = (x) => x.t === 'int' || x.t === 'float' || x.t === 'bool';
function numOf(x) {
  if (x.t === 'int') return rat(x.v);
  if (x.t === 'float') return x.v;
  if (x.t === 'bool') return x.v ? ONE : ZERO;
  return null;
}
function pyEq(a, b) {
  const x = numOf(a);
  const y = numOf(b);
  if (x && y) return eq(x, y);
  if (a.t === 'str' && b.t === 'str') return a.v === b.v;
  if (a.t === 'none' && b.t === 'none') return true;
  if ((a.t === 'list' && b.t === 'list') || (a.t === 'tuple' && b.t === 'tuple'))
    return a.items.length === b.items.length && a.items.every((v, i) => pyEq(v, b.items[i]));
  if (a.t === 'range' && b.t === 'range')
    return a.start === b.start && a.stop === b.stop && a.step === b.step;
  return false;
}
function clone(x) {
  if (x.t === 'list') return { t: 'list', items: x.items.map(clone) };
  if (x.t === 'tuple') return { t: 'tuple', items: x.items.map(clone) };
  return x;
}
function isFiniteDecimal(q) {
  let d = q.d;
  while (d % 2n === 0n) d /= 2n;
  while (d % 5n === 0n) d /= 5n;
  return d === 1n;
}
function decimalText(q, sep = ',') {
  const neg2 = q.n < 0n;
  const n = neg2 ? -q.n : q.n;
  let places = 0;
  let scale = 1n;
  while ((n * scale) % q.d !== 0n) {
    scale *= 10n;
    places++;
    if (places > 40) break;
  }
  const digits = ((n * scale) / q.d).toString().padStart(places + 1, '0');
  const int = digits.slice(0, digits.length - places);
  const frac = places ? digits.slice(digits.length - places) : '';
  return (neg2 ? '\u2212' : '') + int + (frac ? sep + frac : '');
}
function decimalPlaces(q) {
  let d = q.d;
  let twos = 0;
  let fives = 0;
  while (d % 2n === 0n) {
    d /= 2n;
    twos++;
  }
  while (d % 5n === 0n) {
    d /= 5n;
    fives++;
  }
  return Math.max(twos, fives);
}
function doubleText(q, sep, python) {
  const v = Number(q.n) / Number(q.d);
  if (!Number.isFinite(v)) return approxText(q, sep);
  let t = String(v);
  if (python && Number.isInteger(v) && !/e/.test(t)) t += '.0';
  return (v < 0 ? '\u2212' + t.slice(1) : t).replace('.', sep);
}
function approxText(q, sep) {
  const scaled = rat(q.n * 1000000n, q.d);
  const r = (scaled.n * 2n + (scaled.n < 0n ? -scaled.d : scaled.d)) / (2n * scaled.d);
  return decimalText(rat(r, 1000000n), sep);
}
function formatValue(x, python = false) {
  const sep = python ? '.' : ',';
  const minus = (s) => (python ? s.replace(/^−/, '-') : s);
  switch (x.t) {
    case 'int':
      return minus(x.v < 0n ? '\u2212' + (-x.v).toString() : x.v.toString());
    case 'float': {
      if (x.bin || (python && (!isFiniteDecimal(x.v) || decimalPlaces(x.v) > 17)))
        return minus(doubleText(x.v, sep, python));
      const t = minus(isFiniteDecimal(x.v) ? decimalText(x.v, sep) : approxText(x.v, sep));
      return python && x.v.d === 1n ? t + '.0' : t;
    }
    case 'bool':
      return x.v ? 'True' : 'False';
    case 'none':
      return 'None';
    case 'str':
      return python ? JSON.stringify(x.v) : x.v;
    case 'list':
      return '[' + x.items.map((v) => formatValue(v, python)).join(', ') + ']';
    case 'tuple':
      return (
        '(' +
        x.items.map((v) => formatValue(v, python)).join(', ') +
        (x.items.length === 1 ? ',)' : ')')
      );
    case 'range':
      return `range(${x.start}, ${x.stop}${x.step === 1n ? '' : ', ' + x.step})`;
    case 'func':
      return `<fonction ${x.def.name}>`;
    case 'builtin':
      return `<fonction ${x.name}>`;
    case 'module':
      return `<module ${x.name}>`;
    case 'method':
      return `<m\xE9thode ${x.name}>`;
  }
}
function typeName(x) {
  switch (x.t) {
    case 'int':
      return 'un entier';
    case 'float':
      return 'un nombre d\xE9cimal';
    case 'bool':
      return 'un bool\xE9en';
    case 'none':
      return 'None';
    case 'str':
      return 'une cha\xEEne';
    case 'list':
      return 'une liste';
    case 'tuple':
      return 'un tuple';
    case 'range':
      return 'un range';
    default:
      return 'une fonction';
  }
}

// packages/reasoner/src/kernel/python/interp.ts
var MAX_SIM_STEPS = 2e3;
var MAX_EVALS = 5e3;
var RANDOM_FUNCS = /* @__PURE__ */ new Set([
  'randint',
  'random',
  'choice',
  'randrange',
  'uniform',
  'seed',
  'shuffle',
]);
var DEFAULT_MAX_STEPS = 2e4;
var MAX_POINTS = 1e3;
var MAX_DEPTH = 100;
var MAX_LIST = 1e4;
var MAX_BITS = 2048n;
var NORMAL = { k: 'normal' };
var BUILTINS = /* @__PURE__ */ new Set([
  'print',
  'range',
  'len',
  'abs',
  'min',
  'max',
  'sum',
  'int',
  'float',
  'round',
  'str',
  'list',
  'sorted',
  'bool',
  'enumerate',
]);
var MATH_FUNCS = /* @__PURE__ */ new Set(['sqrt', 'floor', 'ceil', 'fabs']);
function floorRat(q) {
  return q.n >= 0n ? q.n / q.d : -((-q.n + q.d - 1n) / q.d);
}
function ceilRat(q) {
  return -floorRat(neg(q));
}
function checkInt(v, line) {
  const a = v < 0n ? -v : v;
  if (a.toString(2).length > Number(MAX_BITS))
    throw new PyError('value', 'Nombre trop grand.', line);
  return v;
}
function checkRat(q, line) {
  checkInt(q.n, line);
  checkInt(q.d, line);
  return q;
}
function sqrtExact(q) {
  if (q.n < 0n) return null;
  const r = (x) => {
    if (x < 2n) return x;
    let y = BigInt(Math.floor(Math.sqrt(Number(x))));
    while (y * y > x) y--;
    while ((y + 1n) * (y + 1n) <= x) y++;
    return y * y === x ? y : null;
  };
  const a = r(q.n);
  const b = r(q.d);
  return a !== null && b !== null ? rat(a, b) : null;
}
function truthy(x) {
  switch (x.t) {
    case 'bool':
      return x.v;
    case 'int':
      return x.v !== 0n;
    case 'float':
      return x.v.n !== 0n;
    case 'none':
      return false;
    case 'str':
      return x.v.length > 0;
    case 'list':
    case 'tuple':
      return x.items.length > 0;
    case 'range':
      return rangeLen(x) > 0n;
    default:
      return true;
  }
}
function rangeLen(r) {
  if (r.step > 0n) return r.stop > r.start ? (r.stop - r.start + r.step - 1n) / r.step : 0n;
  return r.start > r.stop ? (r.start - r.stop - r.step - 1n) / -r.step : 0n;
}
function isIntLike(x) {
  return x.t === 'int' || x.t === 'bool';
}
function intOf(x) {
  return x.t === 'int' ? x.v : x.t === 'bool' ? (x.v ? 1n : 0n) : 0n;
}
function arith(op, a, b, line) {
  if (op === '+') {
    if (a.t === 'list' && b.t === 'list') return listOf([...a.items, ...b.items], line);
    if (a.t === 'str' && b.t === 'str') return { t: 'str', v: a.v + b.v };
    if (a.t === 'tuple' && b.t === 'tuple') return { t: 'tuple', items: [...a.items, ...b.items] };
  }
  if (op === '*') {
    const rep = (items, n) => {
      const k = intOf(n);
      if (k * BigInt(items.length) > BigInt(MAX_LIST))
        throw new PyError('value', 'Liste trop longue.', line);
      const out = [];
      for (let i = 0n; i < k; i++) out.push(...items.map(clone));
      return out;
    };
    if (a.t === 'list' && isIntLike(b)) return { t: 'list', items: rep(a.items, b) };
    if (b.t === 'list' && isIntLike(a)) return { t: 'list', items: rep(b.items, a) };
    if (a.t === 'str' && isIntLike(b))
      return { t: 'str', v: a.v.repeat(Math.max(0, Number(intOf(b)))) };
  }
  if (op === '%' && a.t === 'str')
    throw new PyError(
      'unsupported',
      'Le formatage de cha\xEEnes avec % n\u2019est pas pris en charge.',
      line,
    );
  if (!isNumeric(a) || !isNumeric(b))
    throw new PyError(
      'type',
      `Op\xE9ration \xAB ${op} \xBB impossible entre ${typeName(a)} et ${typeName(b)}.`,
      line,
    );
  if (isIntLike(a) && isIntLike(b)) {
    const x2 = intOf(a);
    const y2 = intOf(b);
    switch (op) {
      case '+':
        return pyInt(checkInt(x2 + y2, line));
      case '-':
        return pyInt(checkInt(x2 - y2, line));
      case '*':
        return pyInt(checkInt(x2 * y2, line));
      case '/':
        if (y2 === 0n) throw new PyError('zero_division', 'Division par z\xE9ro.', line);
        return pyFloat(rat(x2, y2));
      case '//':
        if (y2 === 0n) throw new PyError('zero_division', 'Division par z\xE9ro.', line);
        return pyInt(floorRat(rat(x2, y2)));
      case '%': {
        if (y2 === 0n) throw new PyError('zero_division', 'Division par z\xE9ro (reste).', line);
        return pyInt(x2 - y2 * floorRat(rat(x2, y2)));
      }
      case '**': {
        if (y2 < 0n) {
          if (x2 === 0n)
            throw new PyError('zero_division', '0 \xE0 une puissance n\xE9gative.', line);
          if (-y2 > 4096n) throw new PyError('value', 'Exposant trop grand.', line);
          return pyFloat(checkRat(pow(rat(x2), Number(y2)), line));
        }
        if (y2 > 4096n && x2 !== 0n && x2 !== 1n && x2 !== -1n)
          throw new PyError('value', 'Exposant trop grand.', line);
        return pyInt(checkInt(x2 ** (y2 > 4096n ? y2 % 2n : y2), line));
      }
    }
  }
  const x = numOf(a);
  const y = numOf(b);
  switch (op) {
    case '+':
      return pyFloat(checkRat(add(x, y), line));
    case '-':
      return pyFloat(checkRat(sub(x, y), line));
    case '*':
      return pyFloat(checkRat(mul(x, y), line));
    case '/': {
      const r = div(x, y);
      if (!r) throw new PyError('zero_division', 'Division par z\xE9ro.', line);
      return pyFloat(checkRat(r, line));
    }
    case '//': {
      const r = div(x, y);
      if (!r) throw new PyError('zero_division', 'Division par z\xE9ro.', line);
      return pyFloat(rat(floorRat(r)));
    }
    case '%': {
      const r = div(x, y);
      if (!r) throw new PyError('zero_division', 'Division par z\xE9ro (reste).', line);
      return pyFloat(checkRat(sub(x, mul(y, rat(floorRat(r)))), line));
    }
    case '**': {
      if (isInteger(y)) {
        const k = Number(y.n);
        if (Math.abs(k) > 4096) throw new PyError('value', 'Exposant trop grand.', line);
        const r = pow(x, k);
        if (!r) throw new PyError('zero_division', '0 \xE0 une puissance n\xE9gative.', line);
        return pyFloat(checkRat(r, line));
      }
      if (eq(y, rat(1, 2))) {
        const r = sqrtExact(x);
        if (!r)
          throw new PyError(
            'inexact',
            'Cette racine n\u2019a pas de valeur d\xE9cimale exacte.',
            line,
          );
        return pyFloat(r);
      }
      throw new PyError('inexact', 'Puissance non enti\xE8re : pas de valeur exacte.', line);
    }
  }
}
function compare(op, a, b, line) {
  if (op === '==') return pyEq(a, b);
  if (op === '!=') return !pyEq(a, b);
  if (op === 'in' || op === 'not in') {
    let found;
    if (b.t === 'list' || b.t === 'tuple') found = b.items.some((v) => pyEq(v, a));
    else if (b.t === 'range') {
      const v = numOf(a);
      found =
        !!v &&
        isInteger(v) &&
        (b.step > 0n ? v.n >= b.start && v.n < b.stop : v.n <= b.start && v.n > b.stop) &&
        (v.n - b.start) % b.step === 0n;
    } else if (b.t === 'str' && a.t === 'str') found = b.v.includes(a.v);
    else throw new PyError('type', `\xAB in \xBB impossible avec ${typeName(b)}.`, line);
    return op === 'in' ? found : !found;
  }
  const x = numOf(a);
  const y = numOf(b);
  let c;
  if (x && y) c = cmp(x, y);
  else if (a.t === 'str' && b.t === 'str') c = a.v < b.v ? -1 : a.v > b.v ? 1 : 0;
  else
    throw new PyError(
      'type',
      `Comparaison impossible entre ${typeName(a)} et ${typeName(b)}.`,
      line,
    );
  switch (op) {
    case '<':
      return c < 0;
    case '>':
      return c > 0;
    case '<=':
      return c <= 0;
    case '>=':
      return c >= 0;
  }
}
function listOf(items, line) {
  if (items.length > MAX_LIST) throw new PyError('value', 'Liste trop longue.', line);
  return { t: 'list', items };
}
function iterate(x, line) {
  if (x.t === 'list' || x.t === 'tuple') return x.items.slice();
  if (x.t === 'str') return [...x.v].map((c) => ({ t: 'str', v: c }));
  if (x.t === 'range') {
    const n = rangeLen(x);
    if (n > BigInt(MAX_LIST)) throw new PyError('budget', 'Boucle trop longue.', line);
    const out = [];
    for (let i = 0n; i < n; i++) out.push(pyInt(x.start + i * x.step));
    return out;
  }
  throw new PyError('type', `On ne peut pas parcourir ${typeName(x)}.`, line);
}
function indexOf(seq, i, line) {
  if (!isIntLike(i)) throw new PyError('type', 'Un indice doit \xEAtre un entier.', line);
  let k = Number(intOf(i));
  if (k < 0) k += seq.length;
  if (k < 0 || k >= seq.length) throw new PyError('index', 'Indice hors de la liste.', line);
  return k;
}
var PREC = {
  or: 1,
  and: 2,
  not: 3,
  cmp: 4,
  '+': 5,
  '-': 5,
  '*': 6,
  '/': 6,
  '//': 6,
  '%': 6,
  unary: 7,
  '**': 8,
};
function exprText(e, parent = 0) {
  const wrap = (s, p) => (p < parent ? `(${s})` : s);
  switch (e.k) {
    case 'num':
      return e.text;
    case 'str':
      return JSON.stringify(e.v);
    case 'const':
      return e.v;
    case 'name':
      return e.id;
    case 'list':
      return '[' + e.items.map((x) => exprText(x)).join(', ') + ']';
    case 'tuple':
      return '(' + e.items.map((x) => exprText(x)).join(', ') + ')';
    case 'comp':
      return `[${exprText(e.elt)} for \u2026 in ${exprText(e.iter)}]`;
    case 'unary':
      return e.op === 'not'
        ? wrap('not ' + exprText(e.e, PREC.not), PREC.not)
        : wrap(e.op + exprText(e.e, PREC.unary), PREC.unary);
    case 'bin': {
      const p = PREC[e.op];
      return wrap(`${exprText(e.l, p)} ${e.op} ${exprText(e.r, p + 1)}`, p);
    }
    case 'bool': {
      const p = PREC[e.op];
      return wrap(`${exprText(e.l, p)} ${e.op} ${exprText(e.r, p + 1)}`, p);
    }
    case 'compare':
      return wrap(
        [
          exprText(e.first, PREC.cmp + 1),
          ...e.ops.map((o, i) => `${o} ${exprText(e.rest[i], PREC.cmp + 1)}`),
        ].join(' '),
        PREC.cmp,
      );
    case 'call':
      return `${exprText(e.f, 9)}(${e.args.map((a) => exprText(a)).join(', ')})`;
    case 'index':
      return `${exprText(e.e, 9)}[${exprText(e.i)}]`;
    case 'slice':
      return `${exprText(e.e, 9)}[${e.lo ? exprText(e.lo) : ''}:${e.hi ? exprText(e.hi) : ''}]`;
    case 'attr':
      return `${exprText(e.e, 9)}.${e.name}`;
    case 'ifexp':
      return `${exprText(e.body)} if ${exprText(e.test)} else ${exprText(e.orelse)}`;
  }
}
function callAtom(name, args) {
  return `${name}(${args.map((a) => formatValue(a)).join(', ')})`;
}
var Machine = class {
  constructor(maxSteps) {
    this.maxSteps = maxSteps;
    this.stack.push({ id: 0, name: 'Programme', f: this.globals });
  }
  maxSteps;
  steps = 0;
  depth = 0;
  points = [];
  conds = [];
  calls = [];
  output = [];
  focus = null;
  /** nom de la fonction à suivre (appel de la question), pas encore entrée */
  wanted = null;
  globals = { vars: /* @__PURE__ */ new Map(), focus: false };
  evals = [];
  loopSeq = 0;
  /** tirages imposés, et le prochain à donner */
  draws = null;
  drawIdx = 0;
  rng = null;
  seedDefault = 0n;
  /** pile des appels (simulateur) */
  stack = [];
  frameSeq = 0;
  sim = null;
  tick(line) {
    if (++this.steps > this.maxSteps)
      throw new PyError(
        'budget',
        'Le programme ne s\u2019arr\xEAte pas (ou il est trop long).',
        line,
      );
  }
  snapshot(f) {
    const out = {};
    f.vars.forEach((v, k) => {
      if (v.t === 'func' || v.t === 'builtin' || v.t === 'module' || v.t === 'method') return;
      out[k] = clone(v);
    });
    return out;
  }
  /** garder la trace de la fonction suivie (false : tests, simulateur) */
  tracing = true;
  point(f, line, kind = 'assign', ret) {
    if (!f.focus || !this.tracing) return;
    if (this.points.length >= MAX_POINTS) throw new PyError('budget', 'Trace trop longue.', line);
    this.points.push({
      kind,
      line,
      vars: this.snapshot(f),
      end: kind === 'return',
      ...(kind === 'return' ? { unit: 'return', ret: clone(ret) } : {}),
    });
  }
  markEnd(f, from, unit, loop) {
    if (!f.focus || this.points.length <= from) return;
    const p = this.points[this.points.length - 1];
    if (p.end) return;
    p.end = true;
    p.unit = unit;
    if (loop) p.loop = loop;
  }
  /* ---- simulateur : un pas après chaque instruction, test, appel, retour ---- */
  simRec(kind, line, label, extra = {}) {
    const sim = this.sim;
    if (!sim) return;
    if (sim.steps.length >= MAX_SIM_STEPS) {
      sim.truncated = true;
      return;
    }
    const prev = sim.steps[sim.steps.length - 1];
    const frames = this.stack.map(({ id, name, f }) => {
      const before = prev?.frames.find((x) => x.id === id);
      const vars = [];
      f.vars.forEach((v, k) => {
        if (v.t === 'func' || v.t === 'builtin' || v.t === 'module' || v.t === 'method') return;
        const value = formatValue(v, true);
        const old = before?.vars.find((x) => x.name === k);
        vars.push({ name: k, value, changed: !old || old.value !== value });
      });
      return { id, name, vars };
    });
    sim.steps.push({ line, kind, label, frames, output: this.output.slice(), ...extra });
  }
  srcLine(line) {
    return (this.sim?.lines[line - 1] ?? '').trim();
  }
  lookup(f, id, line) {
    const v = f.vars.get(id) ?? this.globals.vars.get(id);
    if (v) return v;
    if (BUILTINS.has(id)) return { t: 'builtin', name: id };
    throw new PyError('name', `La variable \xAB ${id} \xBB n\u2019existe pas (encore).`, line);
  }
  /* ---- instructions ---- */
  execBody(body, f, level) {
    let run = -1;
    const top = f.focus && level === 0;
    for (let idx = 0; idx < body.length; idx++) {
      const s = body[idx];
      const simple = !isCompound(s) && s.k !== 'return';
      if (top) {
        if (simple) {
          if (run < 0) run = this.points.length;
        } else if (run >= 0) {
          this.markEnd(f, run, 'block');
          run = -1;
        }
      }
      const r = this.exec(s, f, level);
      if (r.k !== 'normal') {
        if (top && run >= 0) this.markEnd(f, run, 'block');
        return r;
      }
    }
    if (top && run >= 0) this.markEnd(f, run, 'block');
    return NORMAL;
  }
  exec(s, f, level) {
    this.tick(s.line);
    switch (s.k) {
      case 'pass':
        this.simRec('stmt', s.line, 'pass : rien \xE0 faire');
        return NORMAL;
      case 'break':
        this.simRec('stmt', s.line, 'break : on sort de la boucle');
        return { k: 'break' };
      case 'continue':
        this.simRec('stmt', s.line, 'continue : on passe au tour suivant');
        return { k: 'continue' };
      case 'import':
        this.doImport(s);
        this.simRec('stmt', s.line, this.srcLine(s.line));
        return NORMAL;
      case 'def':
        f.vars.set(s.name, { t: 'func', def: s });
        this.simRec(
          'stmt',
          s.line,
          `La fonction ${s.name} est d\xE9finie (elle ne s\u2019ex\xE9cute pas encore)`,
        );
        return NORMAL;
      case 'expr': {
        const e = s.e;
        this.eval(e, f);
        if (e.k === 'call' && e.f.k === 'attr') this.point(f, s.line);
        this.simRec('stmt', s.line, this.srcLine(s.line));
        return NORMAL;
      }
      case 'assign': {
        const v = this.eval(s.value, f);
        s.targets.forEach((t) => this.assign(t, s.targets.length > 1 ? clone(v) : v, f));
        this.point(f, s.line);
        this.simRec('stmt', s.line, this.srcLine(s.line));
        return NORMAL;
      }
      case 'aug': {
        const cur = this.eval(targetExpr(s.target), f);
        const v = this.eval(s.value, f);
        if (cur.t === 'list' && s.op === '+' && v.t === 'list') {
          cur.items.push(...v.items.map(clone));
          if (cur.items.length > MAX_LIST) throw new PyError('value', 'Liste trop longue.', s.line);
        } else this.assign(s.target, arith(s.op, cur, v, s.line), f);
        this.point(f, s.line);
        this.simRec('stmt', s.line, this.srcLine(s.line));
        return NORMAL;
      }
      case 'return': {
        const v = s.value ? this.eval(s.value, f) : NONE;
        this.point(f, s.line, 'return', v);
        const shown = formatValue(v, true);
        this.simRec('return', s.line, `La fonction renvoie ${shown}`, { ret: shown });
        return { k: 'return', v };
      }
      case 'if': {
        const from = this.points.length;
        const r = this.execIf(s, f, level);
        if (f.focus && level === 0) this.markEnd(f, from, 'branch');
        return r;
      }
      case 'while': {
        const loop = f.focus ? ++this.loopSeq : 0;
        for (;;) {
          if (!this.test(s.test, f, s.line, true)) return NORMAL;
          this.tick(s.line);
          const from = this.points.length;
          const r = this.execBody(s.body, f, level + 1);
          this.markEnd(f, from, 'iteration', loop);
          if (r.k === 'break') return NORMAL;
          if (r.k === 'return') return r;
        }
      }
      case 'for': {
        const loop = f.focus ? ++this.loopSeq : 0;
        const items = iterate(this.eval(s.iter, f), s.line);
        for (const it of items) {
          this.tick(s.line);
          const from = this.points.length;
          this.assign(s.target, it, f);
          this.point(f, s.line);
          this.simRec(
            'stmt',
            s.line,
            `Nouveau tour : ${targetText(s.target)} prend la valeur ${formatValue(it, true)}`,
          );
          const r = this.execBody(s.body, f, level + 1);
          this.markEnd(f, from, 'iteration', loop);
          if (r.k === 'break') return NORMAL;
          if (r.k === 'return') return r;
        }
        this.simRec('stmt', s.line, 'La boucle for est finie');
        return NORMAL;
      }
    }
  }
  execIf(s, f, level) {
    if (this.test(s.test, f, s.line, false)) return this.execBody(s.body, f, level + 1);
    if (s.orelse.length === 1 && s.orelse[0].k === 'if' && s.orelse[0].elif)
      return this.execIf(s.orelse[0], f, level);
    return s.orelse.length ? this.execBody(s.orelse, f, level + 1) : NORMAL;
  }
  /**
   * Issue d'un test et la comparaison qui la DÉCIDE (valeurs des deux membres) : la
   * comparaison elle-même, ou, pour « a or b » / « a and b » (moteur v29), l'opérande qui
   * décide, évalué en court-circuit comme Python (« âge ≥ 65 » décide « âge < 12 or
   * âge ≥ 65 » pour âge = 65). Même nombre d'évaluations que `eval`.
   */
  decide(e, f, line) {
    if (e.k === 'compare' && e.ops.length === 1 && e.ops[0] !== 'in' && e.ops[0] !== 'not in') {
      const l = this.eval(e.first, f);
      const r = this.eval(e.rest[0], f);
      return {
        result: compare(e.ops[0], l, r, line),
        cmp: { l: clone(l), op: e.ops[0], r: clone(r) },
      };
    }
    if (e.k === 'bool') {
      const a = this.decide(e.l, f, line);
      if (e.op === 'or' ? a.result : !a.result) return a;
      return this.decide(e.r, f, line);
    }
    return { result: truthy(this.eval(e, f)), cmp: null };
  }
  /** évalue un test ; dans la fonction suivie, le note (valeurs des deux membres) */
  test(e, f, line, loop) {
    const { result, cmp: cmp2 } = this.decide(e, f, line);
    if (f.focus && this.tracing)
      this.conds.push({
        after: this.points.length - 1,
        line,
        loop,
        result,
        text: exprText(e),
        cmp: cmp2,
      });
    const text = exprText(e);
    this.simRec(
      'cond',
      line,
      `${text} est ${result ? 'vrai' : 'faux'} : ${loop ? (result ? 'on fait un tour de boucle' : 'la boucle s\u2019arr\xEAte') : result ? 'on ex\xE9cute le bloc' : 'on saute le bloc'}`,
      { cond: { text, result } },
    );
    return result;
  }
  doImport(s) {
    const mods = s.from ? [s.from] : s.names;
    for (const mod of mods)
      if (mod !== 'math' && mod !== 'random')
        throw new PyError(
          'unsupported',
          `Le module \xAB ${mod} \xBB n\u2019est pas pris en charge.`,
          s.line,
        );
    if (!s.from) {
      s.names.forEach((m) => this.globals.vars.set(m, { t: 'module', name: m }));
      return;
    }
    const known = s.from === 'math' ? MATH_FUNCS : RANDOM_FUNCS;
    const names = s.names[0] === '*' ? [...known] : s.names;
    names.forEach((n) => {
      if (!known.has(n))
        throw new PyError('unsupported', `${s.from}.${n} n\u2019est pas pris en charge.`, s.line);
      this.globals.vars.set(n, { t: 'builtin', name: `${s.from}.${n}` });
    });
  }
  assign(t, v, f) {
    if (t.k === 'name') {
      f.vars.set(t.id, v);
      return;
    }
    if (t.k === 'tuple') {
      const items = iterate(v, t.line);
      if (items.length !== t.items.length)
        throw new PyError(
          'value',
          `${t.items.length} variables pour ${items.length} valeurs.`,
          t.line,
        );
      t.items.forEach((x, i) => this.assign(x, items[i], f));
      return;
    }
    const seq = this.eval(t.e, f);
    if (seq.t !== 'list')
      throw new PyError('type', `On ne peut pas modifier ${typeName(seq)}.`, t.line);
    seq.items[indexOf(seq.items, this.eval(t.i, f), t.line)] = v;
  }
  /* ---- expressions ---- */
  eval(e, f) {
    switch (e.k) {
      case 'num': {
        if (/[.eE]/.test(e.text)) {
          const m = /^(\d*)\.?(\d*)(?:[eE]([+-]?\d+))?$/.exec(e.text);
          const digits = (m[1] || '0') + (m[2] ?? '');
          let q = rat(BigInt(digits), 10n ** BigInt((m[2] ?? '').length));
          const ex = Number(m[3] ?? 0);
          if (Math.abs(ex) > 300) throw new PyError('value', 'Nombre trop grand.', e.line);
          if (ex) q = mul(q, pow(rat(10), ex));
          return pyFloat(q);
        }
        return pyInt(BigInt(e.text));
      }
      case 'str':
        return { t: 'str', v: e.v };
      case 'const':
        return e.v === 'None' ? NONE : pyBool(e.v === 'True');
      case 'name':
        return this.lookup(f, e.id, e.line);
      case 'list':
        return listOf(
          e.items.map((x) => this.eval(x, f)),
          e.line,
        );
      case 'tuple':
        return { t: 'tuple', items: e.items.map((x) => this.eval(x, f)) };
      case 'comp': {
        const out = [];
        const saved = new Map(f.vars);
        for (const it of iterate(this.eval(e.iter, f), e.line)) {
          this.tick(e.line);
          this.assign(e.target, it, f);
          if (!e.cond || truthy(this.eval(e.cond, f))) out.push(this.eval(e.elt, f));
        }
        f.vars.clear();
        saved.forEach((v, k) => f.vars.set(k, v));
        return listOf(out, e.line);
      }
      case 'unary': {
        const v = this.eval(e.e, f);
        if (e.op === 'not') return pyBool(!truthy(v));
        if (!isNumeric(v))
          throw new PyError('type', `\xAB ${e.op} \xBB impossible devant ${typeName(v)}.`, e.line);
        if (e.op === '+') return v.t === 'bool' ? pyInt(intOf(v)) : v;
        return v.t === 'float' ? pyFloat(neg(v.v)) : pyInt(-intOf(v));
      }
      case 'bin': {
        const l = this.eval(e.l, f);
        const r = this.eval(e.r, f);
        const v = arith(e.op, l, r, e.line);
        if (
          f.focus &&
          this.tracing &&
          this.evals.length < MAX_EVALS &&
          isNumeric(l) &&
          isNumeric(r)
        )
          this.evals.push({
            after: this.points.length - 1,
            line: e.line,
            op: e.op,
            l: clone(l),
            r: clone(r),
            v: clone(v),
            text: exprText(e),
          });
        return v;
      }
      case 'bool': {
        const l = this.eval(e.l, f);
        if (e.op === 'and') return truthy(l) ? this.eval(e.r, f) : l;
        return truthy(l) ? l : this.eval(e.r, f);
      }
      case 'compare': {
        let l = this.eval(e.first, f);
        for (let i = 0; i < e.ops.length; i++) {
          const r = this.eval(e.rest[i], f);
          if (!compare(e.ops[i], l, r, e.line)) return pyBool(false);
          l = r;
        }
        return pyBool(true);
      }
      case 'ifexp':
        return truthy(this.eval(e.test, f)) ? this.eval(e.body, f) : this.eval(e.orelse, f);
      case 'index': {
        const s = this.eval(e.e, f);
        const i = this.eval(e.i, f);
        if (s.t === 'list' || s.t === 'tuple') return s.items[indexOf(s.items, i, e.line)];
        if (s.t === 'str')
          return {
            t: 'str',
            v: [...s.v][
              indexOf(
                [...s.v].map(() => NONE),
                i,
                e.line,
              )
            ],
          };
        throw new PyError('type', `On ne peut pas indexer ${typeName(s)}.`, e.line);
      }
      case 'slice': {
        const s = this.eval(e.e, f);
        if (s.t !== 'list' && s.t !== 'str')
          throw new PyError('type', `Tranche impossible sur ${typeName(s)}.`, e.line);
        const items = s.t === 'list' ? s.items : [...s.v].map((c) => ({ t: 'str', v: c }));
        const n = items.length;
        const bound = (x, d) => {
          if (!x) return d;
          const v = this.eval(x, f);
          if (!isIntLike(v))
            throw new PyError('type', 'Une borne de tranche doit \xEAtre un entier.', e.line);
          let k = Number(intOf(v));
          if (k < 0) k += n;
          return Math.min(Math.max(k, 0), n);
        };
        if (e.step)
          throw new PyError(
            'unsupported',
            'Les tranches avec un pas ne sont pas prises en charge.',
            e.line,
          );
        const out = items.slice(bound(e.lo, 0), bound(e.hi, n));
        return s.t === 'list'
          ? { t: 'list', items: out.map(clone) }
          : { t: 'str', v: out.map((c) => c.v).join('') };
      }
      case 'attr': {
        const o = this.eval(e.e, f);
        if (o.t === 'module') {
          const known = o.name === 'math' ? MATH_FUNCS : RANDOM_FUNCS;
          if (!known.has(e.name))
            throw new PyError(
              'unsupported',
              `${o.name}.${e.name} n\u2019est pas pris en charge.`,
              e.line,
            );
          return { t: 'builtin', name: `${o.name}.${e.name}` };
        }
        if (o.t === 'list') return { t: 'method', self: o, name: e.name };
        throw new PyError(
          'unsupported',
          `\xAB .${e.name} \xBB n\u2019est pas pris en charge.`,
          e.line,
        );
      }
      case 'call':
        return this.call(e, f);
    }
  }
  call(e, f) {
    const fn = this.eval(e.f, f);
    const args = e.args.map((a) => this.eval(a, f));
    if (fn.t === 'func') {
      const v = this.callUser(fn.def, args, e.line, f);
      if (f.focus && this.tracing)
        this.calls.push({
          after: this.points.length - 1,
          name: fn.def.name,
          atom: callAtom(fn.def.name, args),
          value: v,
        });
      return v;
    }
    if (fn.t === 'builtin') return this.builtin(fn.name, args, e.line);
    if (fn.t === 'method') return this.method(fn.self, fn.name, args, e.line);
    throw new PyError('type', `${formatValue(fn)} n\u2019est pas une fonction.`, e.line);
  }
  callUser(def, args, line, caller) {
    if (args.length !== def.params.length)
      throw new PyError(
        'type',
        `${def.name} attend ${def.params.length} argument${def.params.length > 1 ? 's' : ''}, pas ${args.length}.`,
        line,
      );
    if (++this.depth > MAX_DEPTH)
      throw new PyError('recursion', 'Trop d\u2019appels imbriqu\xE9s.', line);
    const focus = this.wanted === def.name && !caller.focus && !this.focus;
    const frame = { vars: /* @__PURE__ */ new Map(), focus };
    def.params.forEach((p, i) => frame.vars.set(p, args[i]));
    const atom = `${def.name}(${args.map((a) => formatValue(a, true)).join(', ')})`;
    this.stack.push({ id: ++this.frameSeq, name: atom, f: frame });
    this.simRec('call', def.line, `Appel de ${atom}`);
    if (focus) {
      this.wanted = null;
      this.focus = {
        name: def.name,
        args: args.map(clone),
        atom: callAtom(def.name, args),
        value: null,
      };
      if (this.tracing)
        this.points.push({ kind: 'start', line: def.line, vars: this.snapshot(frame), end: true });
    }
    const r = this.execBody(def.body, frame, 0);
    this.depth--;
    const v = r.k === 'return' ? r.v : NONE;
    if (r.k !== 'return')
      this.simRec('return', def.line, 'Fin de la fonction, sans return : elle renvoie None', {
        ret: 'None',
      });
    this.stack.pop();
    if (focus) {
      if (r.k !== 'return' && this.tracing)
        this.points.push({
          kind: 'return',
          line: def.line,
          vars: this.snapshot(frame),
          end: true,
          unit: 'return',
          ret: NONE,
        });
      this.focus.value = clone(v);
    }
    return v;
  }
  builtin(name, args, line) {
    const one = () => {
      if (args.length !== 1) throw new PyError('type', `${name} attend un argument.`, line);
      return args[0];
    };
    const nums = (xs) =>
      xs.map((x) => {
        if (!isNumeric(x))
          throw new PyError('type', `${name} : ${typeName(x)} n\u2019est pas un nombre.`, line);
        return x;
      });
    switch (name) {
      case 'print':
        this.output.push(args.map((a) => (a.t === 'str' ? a.v : formatValue(a, true))).join(' '));
        return NONE;
      case 'range': {
        if (!args.length || args.length > 3 || !args.every(isIntLike))
          throw new PyError('type', 'range attend 1 \xE0 3 entiers.', line);
        const [a, b, c] = args.map(intOf);
        if (args.length === 1) return { t: 'range', start: 0n, stop: a, step: 1n };
        if (c === 0n) throw new PyError('value', 'Le pas de range ne peut pas \xEAtre 0.', line);
        return { t: 'range', start: a, stop: b, step: c ?? 1n };
      }
      case 'len': {
        const x = one();
        if (x.t === 'list' || x.t === 'tuple') return pyInt(x.items.length);
        if (x.t === 'str') return pyInt([...x.v].length);
        if (x.t === 'range') return pyInt(rangeLen(x));
        throw new PyError('type', `len impossible sur ${typeName(x)}.`, line);
      }
      case 'abs': {
        const x = nums([one()])[0];
        return x.t === 'float' ? pyFloat(abs(x.v)) : pyInt(intOf(x) < 0n ? -intOf(x) : intOf(x));
      }
      case 'min':
      case 'max':
      case 'sum': {
        const xs = args.length === 1 ? iterate(args[0], line) : args;
        if (name === 'sum') return nums(xs).reduce((s, x) => arith('+', s, x, line), pyInt(0));
        if (!xs.length) throw new PyError('value', `${name} d\u2019une liste vide.`, line);
        return xs.reduce((m, x) => {
          const lt = compare('<', x, m, line);
          return name === 'min' ? (lt ? x : m) : compare('>', x, m, line) ? x : m;
        });
      }
      case 'int': {
        const x = one();
        if (x.t === 'str') {
          if (!/^\s*[+-]?\d+\s*$/.test(x.v))
            throw new PyError('value', 'Ce n\u2019est pas un entier.', line);
          return pyInt(BigInt(x.v.trim()));
        }
        const q = numOf(nums([x])[0]);
        return pyInt(q.n >= 0n ? q.n / q.d : -(-q.n / q.d));
      }
      case 'float': {
        const x = one();
        if (x.t === 'str') {
          const q = parseDecimal(x.v.replace(',', '#'));
          if (!q) throw new PyError('value', 'Ce n\u2019est pas un nombre.', line);
          return pyFloat(q);
        }
        return pyFloat(numOf(nums([x])[0]));
      }
      case 'round': {
        if (!args.length || args.length > 2)
          throw new PyError('type', 'round attend 1 ou 2 arguments.', line);
        const q = numOf(nums([args[0]])[0]);
        const k = args.length === 2 ? Number(intOf(args[1])) : 0;
        if (k < 0 || k > 20)
          throw new PyError('unsupported', 'round : nombre de chiffres non pris en charge.', line);
        const scale = 10n ** BigInt(k);
        const s = mul(q, rat(scale));
        const fl = floorRat(s);
        const diff = sub(s, rat(fl));
        const c = cmp(diff, rat(1, 2));
        const r = c < 0 ? fl : c > 0 ? fl + 1n : fl % 2n === 0n ? fl : fl + 1n;
        if (args.length === 1) return pyInt(r);
        return args[0].t === 'float' ? pyFloat(rat(r, scale)) : args[0];
      }
      case 'str':
        return { t: 'str', v: formatValue(one(), true) };
      case 'bool':
        return pyBool(truthy(one()));
      case 'list':
        return listOf(args.length ? iterate(one(), line).map(clone) : [], line);
      case 'sorted': {
        const xs = iterate(one(), line).map(clone);
        xs.sort((a, b) => (compare('<', a, b, line) ? -1 : compare('>', a, b, line) ? 1 : 0));
        return listOf(xs, line);
      }
      case 'enumerate':
        return listOf(
          iterate(one(), line).map((x, i) => ({ t: 'tuple', items: [pyInt(i), x] })),
          line,
        );
      case 'math.sqrt': {
        const q = numOf(nums([one()])[0]);
        if (q.n < 0n) throw new PyError('value', 'Racine d\u2019un nombre n\xE9gatif.', line);
        const r = sqrtExact(q);
        if (!r)
          throw new PyError(
            'inexact',
            'Cette racine n\u2019a pas de valeur d\xE9cimale exacte.',
            line,
          );
        return pyFloat(r);
      }
      case 'math.floor':
        return pyInt(floorRat(numOf(nums([one()])[0])));
      case 'math.ceil':
        return pyInt(ceilRat(numOf(nums([one()])[0])));
      case 'math.fabs':
        return pyFloat(abs(numOf(nums([one()])[0])));
    }
    if (name.startsWith('random.')) return this.randomCall(name.slice(7), args, line);
    throw new PyError('unsupported', `${name} n\u2019est pas pris en charge.`, line);
  }
  /* ---- module random : tirages imposés, sinon le générateur de CPython ---- */
  generator() {
    if (!this.rng) this.rng = new MersenneTwister(this.seedDefault);
    return this.rng;
  }
  /** le prochain tirage imposé (null : pas de tirages imposés) */
  takeDraw(line) {
    if (!this.draws) return null;
    if (this.drawIdx >= this.draws.length)
      throw new PyError(
        'value',
        `Plus de tirage : l\u2019\xE9nonc\xE9 en donne ${this.draws.length}.`,
        line,
      );
    return this.draws[this.drawIdx++];
  }
  randomCall(fn, args, line) {
    const ints = (k) => {
      if (!k.includes(args.length) || !args.every(isIntLike))
        throw new PyError('type', `${fn} attend des entiers.`, line);
      return args.map(intOf);
    };
    const drawNo = () => this.drawIdx;
    const bad = (d, what) =>
      new PyError(
        'value',
        `Le tirage n\xB0 ${drawNo()} (${formatValue(d)}) n\u2019est pas ${what}.`,
        line,
      );
    switch (fn) {
      case 'seed': {
        if (args.length > 1 || (args.length === 1 && !isIntLike(args[0])))
          throw new PyError('unsupported', 'random.seed : une graine enti\xE8re.', line);
        if (!this.draws) this.generator().seed(args.length ? intOf(args[0]) : 0n);
        return NONE;
      }
      case 'random': {
        if (args.length)
          throw new PyError('type', 'random() n\u2019attend pas d\u2019argument.', line);
        const d = this.takeDraw(line);
        if (d) {
          const q = numOf(d);
          if (!q || d.t === 'bool' || q.n < 0n || cmp(q, ONE) >= 0)
            throw bad(d, 'entre 0 (compris) et 1 (exclu)');
          return pyFloat(q);
        }
        const r = this.generator().random();
        return { t: 'float', v: rat(r.n, r.d), bin: true };
      }
      case 'uniform': {
        if (args.length !== 2 || !args.every(isNumeric))
          throw new PyError('type', 'uniform attend deux nombres.', line);
        const a = numOf(args[0]);
        const b = numOf(args[1]);
        const d = this.takeDraw(line);
        if (d) {
          const q = numOf(d);
          const lo = cmp(a, b) <= 0 ? a : b;
          const hi = cmp(a, b) <= 0 ? b : a;
          if (!q || d.t === 'bool' || cmp(q, lo) < 0 || cmp(q, hi) > 0)
            throw bad(d, `entre ${formatValue(args[0])} et ${formatValue(args[1])}`);
          return pyFloat(q);
        }
        const r = this.generator().random();
        return pyFloat(add(a, mul(sub(b, a), rat(r.n, r.d))));
      }
      case 'randint':
      case 'randrange': {
        let start;
        let stop;
        let step = 1n;
        if (fn === 'randint') {
          const [a, b] = ints([2]);
          start = a;
          stop = b + 1n;
        } else {
          const xs = ints([1, 2, 3]);
          if (xs.length === 1) {
            start = 0n;
            stop = xs[0];
          } else {
            start = xs[0];
            stop = xs[1];
            step = xs[2] ?? 1n;
          }
        }
        if (step === 0n) throw new PyError('value', `${fn} : le pas ne peut pas \xEAtre 0.`, line);
        const n = step > 0n ? (stop - start + step - 1n) / step : (stop - start + step + 1n) / step;
        if (n <= 0n) throw new PyError('value', `${fn} : intervalle vide.`, line);
        const d = this.takeDraw(line);
        if (d) {
          const k = isIntLike(d) && d.t !== 'bool' ? intOf(d) : null;
          const ok =
            k !== null &&
            (k - start) % step === 0n &&
            (k - start) / step >= 0n &&
            (k - start) / step < n;
          if (!ok)
            throw bad(
              d,
              fn === 'randint'
                ? `un entier entre ${start} et ${stop - 1n}`
                : `une valeur possible de ${fn}`,
            );
          return pyInt(k);
        }
        return pyInt(start + step * this.generator().randbelow(n));
      }
      case 'choice': {
        if (args.length !== 1) throw new PyError('type', 'choice attend une liste.', line);
        const items = iterate(args[0], line);
        if (!items.length) throw new PyError('index', 'choice sur une liste vide.', line);
        const d = this.takeDraw(line);
        if (d) {
          const hit = items.find((x) => pyEq(x, d));
          if (!hit) throw bad(d, 'un \xE9l\xE9ment de la liste');
          return hit;
        }
        return items[Number(this.generator().randbelow(BigInt(items.length)))];
      }
      case 'shuffle': {
        const L = args[0];
        if (args.length !== 1 || !L || L.t !== 'list')
          throw new PyError('type', 'shuffle attend une liste.', line);
        if (this.draws)
          throw new PyError(
            'unsupported',
            'shuffle avec des tirages impos\xE9s n\u2019est pas pris en charge.',
            line,
          );
        const x = L.items;
        for (let i = x.length - 1; i > 0; i--) {
          const j = Number(this.generator().randbelow(BigInt(i + 1)));
          [x[i], x[j]] = [x[j], x[i]];
        }
        return NONE;
      }
    }
    throw new PyError('unsupported', `random.${fn} n\u2019est pas pris en charge.`, line);
  }
  method(self, name, args, line) {
    if (self.t !== 'list')
      throw new PyError('unsupported', `\xAB .${name} \xBB n\u2019est pas pris en charge.`, line);
    const L = self.items;
    switch (name) {
      case 'append':
        if (args.length !== 1) throw new PyError('type', 'append attend un argument.', line);
        if (L.length >= MAX_LIST) throw new PyError('value', 'Liste trop longue.', line);
        L.push(args[0]);
        return NONE;
      case 'pop': {
        if (!L.length) throw new PyError('index', 'pop sur une liste vide.', line);
        const k = args.length ? indexOf(L, args[0], line) : L.length - 1;
        return L.splice(k, 1)[0];
      }
      case 'insert': {
        if (args.length !== 2 || !isIntLike(args[0]))
          throw new PyError('type', 'insert attend un indice et une valeur.', line);
        let k = Number(intOf(args[0]));
        if (k < 0) k = Math.max(0, k + L.length);
        L.splice(Math.min(k, L.length), 0, args[1]);
        return NONE;
      }
      case 'remove': {
        const k = L.findIndex((x) => pyEq(x, args[0]));
        if (k < 0) throw new PyError('value', 'Valeur absente de la liste.', line);
        L.splice(k, 1);
        return NONE;
      }
      case 'count':
        return pyInt(L.filter((x) => pyEq(x, args[0])).length);
      case 'index': {
        const k = L.findIndex((x) => pyEq(x, args[0]));
        if (k < 0) throw new PyError('value', 'Valeur absente de la liste.', line);
        return pyInt(k);
      }
      case 'reverse':
        L.reverse();
        return NONE;
      case 'sort':
        L.sort((a, b) => (compare('<', a, b, line) ? -1 : compare('>', a, b, line) ? 1 : 0));
        return NONE;
    }
    throw new PyError('unsupported', `\xAB .${name} \xBB n\u2019est pas pris en charge.`, line);
  }
};
function targetText(t) {
  if (t.k === 'name') return t.id;
  if (t.k === 'index') return exprText({ k: 'index', e: t.e, i: t.i, line: t.line });
  return t.items.map(targetText).join(', ');
}
function targetExpr(t) {
  if (t.k === 'name') return { k: 'name', id: t.id, line: t.line };
  if (t.k === 'index') return { k: 'index', e: t.e, i: t.i, line: t.line };
  return { k: 'tuple', items: t.items.map(targetExpr), line: t.line };
}
function runProgram(code, opts = {}) {
  const m = new Machine(opts.maxSteps ?? DEFAULT_MAX_STEPS);
  const error = execute(m, code, opts);
  return {
    ok: !error,
    error,
    points: m.points,
    conds: m.conds,
    calls: m.calls,
    focus: m.focus,
    output: m.output,
    steps: m.steps,
    globals: m.snapshot(m.globals),
    evals: m.evals,
    drawsUsed: m.drawIdx,
  };
}
function execute(m, code, opts) {
  let error = null;
  if (opts.draws) m.draws = opts.draws;
  if (opts.seed !== void 0) m.seedDefault = opts.seed;
  if (opts.trace === false) m.tracing = false;
  try {
    const mod = parseProgram(code);
    let callExpr = null;
    if (opts.call) {
      callExpr = parseExpression(opts.call);
      if (callExpr.k !== 'call' || callExpr.f.k !== 'name')
        throw new PyError(
          'syntax',
          'L\u2019appel suivi doit s\u2019\xE9crire \xAB f(\u2026) \xBB.',
          1,
        );
    } else {
      m.globals.focus = true;
      if (m.tracing) m.points.push({ kind: 'start', line: 0, vars: {}, end: true });
    }
    m.execBody(mod.body, m.globals, 0);
    if (callExpr && callExpr.k === 'call' && callExpr.f.k === 'name') {
      m.wanted = callExpr.f.id;
      m.eval(callExpr, m.globals);
      if (!m.focus)
        throw new PyError(
          'name',
          `La fonction \xAB ${m.wanted} \xBB n\u2019est pas d\xE9finie.`,
          1,
        );
    }
  } catch (e) {
    if (!(e instanceof PyError)) throw e;
    error = e;
  }
  return error;
}
function evalCall(code, call, maxSteps = DEFAULT_MAX_STEPS, opts = {}) {
  const t = runProgram(code, { call, maxSteps, ...opts });
  return t.ok && t.focus ? t.focus.value : null;
}

// packages/reasoner/src/kernel-python.ts
var PYTHON_STEP_IDS = {
  block: 'python.block@1',
  iteration: 'python.iteration@1',
  branch: 'python.branch@1',
  return: 'python.return@1',
  assign: 'python.assign@1',
  condition: 'python.condition@1',
  call: 'python.call@1',
  conclude: 'python.conclude@1',
  // moteur v29
  eval: 'python.eval@1',
  jump: 'python.jump@1',
  complete: 'python.complete@1',
};
var PYTHON_JUMP_MIN_TOURS = 15;
var JUMP_AFTER_TOURS = 2;
var CARD = 'Algorithmique';
var ProgLineError = class extends Error {};
var Incomplete = class extends Error {};
var IDENT = /[A-Za-z_À-ɏ]/;
var IDENT_REST = /[A-Za-z0-9_À-ɏ]/;
var NAME_RE = /^[A-Za-z_À-ɏ][A-Za-z0-9_À-ɏ]*$/;
var CALL_RE = /^([A-Za-z_À-ɏ][A-Za-z0-9_À-ɏ]*)\((.*)\)$/;
var NUM_RE = /^−?\d+(,\d+)?$/;
var CMPS = ['<', '>', '\u2264', '\u2265', '\u2260'];
var ARITH = ['+', '\u2212', '\xD7', '\xF7', '%'];
var BOOLS = ['True', 'False', 'None'];
var LIST_SIGNS = ['[', ']', ','];
var OPS2 = /* @__PURE__ */ new Set([
  '=',
  '\u2248',
  ';',
  '(',
  ')',
  ...LIST_SIGNS,
  ...CMPS,
  ...ARITH,
]);
var callKey = (atom) => atom.replace(/\s+/g, '');
function kprogLineAtoms(text) {
  const out = [];
  const s = text.trim();
  let i = 0;
  const prevIsOp = () => !out.length || OPS2.has(out[out.length - 1]);
  while (i < s.length) {
    const c = s[i];
    if (/\s/.test(c)) {
      i++;
      continue;
    }
    if (IDENT.test(c)) {
      let j = i + 1;
      while (j < s.length && IDENT_REST.test(s[j])) j++;
      let k = j;
      while (k < s.length && s[k] === ' ') k++;
      if (s[k] === '(' && !BOOLS.includes(s.slice(i, j))) {
        let depth = 0;
        let m = k;
        for (; m < s.length; m++) {
          if (s[m] === '(' || s[m] === '[') depth++;
          if (s[m] === ')' || s[m] === ']') depth--;
          if (depth === 0) break;
        }
        if (m >= s.length) throw new ProgLineError('Parenth\xE8se non ferm\xE9e.');
        out.push(s.slice(i, j) + s.slice(k, m + 1).replace(/-/g, '\u2212'));
        i = m + 1;
        continue;
      }
      out.push(s.slice(i, j));
      i = j;
      continue;
    }
    const neg2 = (c === '\u2212' || c === '-') && /\d/.test(s[i + 1] ?? '') && prevIsOp();
    if (/\d/.test(c) || neg2) {
      const m = /^[−-]?\d+([.,]\d+)?/.exec(s.slice(i));
      out.push(m[0].replace('-', '\u2212').replace('.', ','));
      i += m[0].length;
      continue;
    }
    const two = s.slice(i, i + 2);
    const map2 = { '<=': '\u2264', '>=': '\u2265', '!=': '\u2260', '==': '=' };
    if (map2[two]) {
      out.push(map2[two]);
      i += 2;
      continue;
    }
    const map1 = { '-': '\u2212', '*': '\xD7', '/': '\xF7' };
    const op = map1[c] ?? c;
    if (!OPS2.has(op))
      throw new ProgLineError(`\xAB ${c} \xBB ne s\u2019\xE9crit pas sur une trace.`);
    out.push(op);
    i++;
  }
  return out;
}
function numAtom(a) {
  return parseDecimal(a);
}
function parseExprAtoms(A, allowNames) {
  let i = 0;
  const peek = () => A[i];
  const primary = () => {
    const a = A[i];
    if (a === void 0) throw new Incomplete();
    if (a === '(') {
      i++;
      const e2 = sum();
      if (A[i] === void 0) throw new Incomplete();
      if (A[i] !== ')') throw new ProgLineError('Parenth\xE8se non ferm\xE9e.');
      i++;
      return e2;
    }
    if (a === '\u2212') {
      i++;
      return { k: 'neg', e: primary() };
    }
    if (a === '[') {
      i++;
      const items = [];
      if (A[i] === ']') {
        i++;
        return { k: 'list', items };
      }
      for (;;) {
        items.push(sum());
        const s = A[i];
        if (s === void 0) throw new Incomplete();
        i++;
        if (s === ']') return { k: 'list', items };
        if (s !== ',')
          throw new ProgLineError('Dans une liste, \xAB , \xBB s\xE9pare deux \xE9l\xE9ments.');
      }
    }
    if (a === ']' || a === ',') throw new ProgLineError(`\xAB ${a} \xBB est mal plac\xE9.`);
    i++;
    if (NUM_RE.test(a)) return { k: 'num', q: numAtom(a) };
    if (a === 'None') return { k: 'none' };
    if (BOOLS.includes(a)) return { k: 'bool', v: a === 'True' };
    if (CALL_RE.test(a)) {
      if (!allowNames) throw new ProgLineError('\xC9cris la valeur, pas un appel.');
      return { k: 'call', atom: a };
    }
    if (NAME_RE.test(a)) {
      if (!allowNames)
        throw new ProgLineError(`\xC9cris la valeur de la variable, pas \xAB ${a} \xBB.`);
      return { k: 'var', name: a };
    }
    throw new ProgLineError(`\xAB ${a} \xBB est mal plac\xE9.`);
  };
  const prod = () => {
    let l = primary();
    while (peek() === '\xD7' || peek() === '\xF7' || peek() === '%') {
      const op = A[i++];
      l = { k: 'bin', op, l, r: primary() };
    }
    return l;
  };
  const sum = () => {
    let l = prod();
    while (peek() === '+' || peek() === '\u2212') {
      const op = A[i++];
      l = { k: 'bin', op, l, r: prod() };
    }
    return l;
  };
  const e = sum();
  if (i < A.length) throw new ProgLineError(`\xAB ${A[i]} \xBB est mal plac\xE9.`);
  return e;
}
function pyMod(x, y) {
  const r = div(x, y);
  if (!r) return null;
  const fl = r.n >= 0n ? r.n / r.d : -((-r.n + r.d - 1n) / r.d);
  return sub(x, mul(y, rat(fl)));
}
function arithOp(op, l, r) {
  return op === '+'
    ? add(l, r)
    : op === '\u2212'
      ? sub(l, r)
      : op === '\xD7'
        ? mul(l, r)
        : op === '%'
          ? pyMod(l, r)
          : div(l, r);
}
function constValue(e) {
  if (e.k === 'bool' || e.k === 'none') return e;
  if (e.k === 'list') {
    const items = e.items.map(constValue);
    return items.every((x) => x !== null) ? { k: 'list', items } : null;
  }
  if (e.k === 'num') return e;
  if (e.k === 'neg') {
    const v = constValue(e.e);
    return v?.k === 'num' ? { k: 'num', q: neg(v.q) } : null;
  }
  if (e.k === 'bin') {
    const l = constValue(e.l);
    const r = constValue(e.r);
    if (l?.k !== 'num' || r?.k !== 'num') return null;
    const q = arithOp(e.op, l.q, r.q);
    return q ? { k: 'num', q } : null;
  }
  return null;
}
function readLine(A) {
  if (!A.length) throw new Incomplete();
  const last = A[A.length - 1];
  if (
    last === ';' ||
    last === '=' ||
    last === '\u2248' ||
    last === '[' ||
    last === ',' ||
    CMPS.includes(last) ||
    ARITH.includes(last) ||
    last === '('
  )
    throw new Incomplete();
  const cmpAt = A.findIndex((a) => CMPS.includes(a));
  if (cmpAt >= 0) {
    if (A.includes(';') || A.includes('=') || A.includes('\u2248'))
      throw new ProgLineError('Une comparaison s\u2019\xE9crit seule sur sa ligne.');
    if (A.slice(cmpAt + 1).some((a) => CMPS.includes(a)))
      throw new ProgLineError('Une seule comparaison par ligne.');
    if (cmpAt === 0) throw new ProgLineError('\xC9cris d\u2019abord ce que tu compares.');
    return {
      kind: 'cmp',
      l: parseExprAtoms(A.slice(0, cmpAt), true),
      op: A[cmpAt],
      r: parseExprAtoms(A.slice(cmpAt + 1), true),
    };
  }
  const segs = [[]];
  A.forEach((a) => (a === ';' ? segs.push([]) : segs[segs.length - 1].push(a)));
  if (segs.length === 1) {
    const seg = segs[0];
    const eq2 = seg.findIndex((a) => a === '=' || a === '\u2248');
    if (eq2 < 0 && seg.length > 1) {
      try {
        parseExprAtoms(seg, true);
      } catch (e) {
        if (e instanceof Incomplete) throw e;
        throw new ProgLineError(
          '\xC9cris \xAB variable = valeur \xBB, ou un calcul \xAB n % 2 = 1 \xBB.',
        );
      }
      throw new Incomplete();
    }
    if (eq2 > 1) {
      if (seg[eq2] === '\u2248')
        throw new ProgLineError('Un calcul du programme s\u2019\xE9crit avec \xAB = \xBB.');
      const e = parseExprAtoms(seg.slice(0, eq2), true);
      if (e.k !== 'bin')
        throw new ProgLineError('Une variable (ou un appel), puis \xAB = \xBB et sa valeur.');
      const rest = seg.slice(eq2 + 1);
      if (rest.some((a) => a === '=' || a === '\u2248'))
        throw new ProgLineError('Un seul \xAB = \xBB dans un calcul.');
      const value = constValue(parseExprAtoms(rest, false));
      if (!value) throw new ProgLineError('Valeur impossible \xE0 calculer.');
      return { kind: 'calc', e, value };
    }
  }
  const claims = segs.map((seg) => {
    if (!seg.length) throw new ProgLineError('Rien entre deux \xAB ; \xBB.');
    const eq2 = seg.findIndex((a) => a === '=' || a === '\u2248');
    if (eq2 < 0) {
      if (seg.length === 1 && (NAME_RE.test(seg[0]) || CALL_RE.test(seg[0])))
        throw new Incomplete();
      throw new ProgLineError('\xC9cris \xAB variable = valeur \xBB.');
    }
    if (eq2 !== 1)
      throw new ProgLineError('Une variable (ou un appel), puis \xAB = \xBB et sa valeur.');
    const target = seg[0];
    const call = CALL_RE.test(target);
    if (!call && (!NAME_RE.test(target) || BOOLS.includes(target)))
      throw new ProgLineError('Une variable (ou un appel), puis \xAB = \xBB et sa valeur.');
    const rest = seg.slice(2);
    if (rest.some((a) => a === '=' || a === '\u2248'))
      throw new ProgLineError('Une seule valeur par variable : s\xE9pare par \xAB ; \xBB.');
    const approx = seg[1] === '\u2248';
    if (approx) {
      if (rest.length !== 1 || !NUM_RE.test(rest[0]))
        throw new ProgLineError('Apr\xE8s \xAB \u2248 \xBB, un nombre arrondi.');
      const places = rest[0].includes(',') ? rest[0].split(',')[1].length : 0;
      return { target, call, value: { k: 'num', q: numAtom(rest[0]) }, approx, places };
    }
    const v = constValue(parseExprAtoms(rest, false));
    if (!v) throw new ProgLineError('Valeur impossible \xE0 calculer.');
    return { target, call, value: v, approx: false, places: 0 };
  });
  const seen = /* @__PURE__ */ new Set();
  claims.forEach((c) => {
    const k = c.call ? callKey(c.target) : c.target;
    if (seen.has(k)) throw new ProgLineError(`\xAB ${c.target} \xBB \xE9crit deux fois.`);
    seen.add(k);
  });
  return { kind: 'claims', claims };
}
function valueKey(v) {
  if (v.k === 'list') return `[${v.items.map(valueKey).join(',')}]`;
  return v.k === 'none' ? 'None' : v.k === 'bool' ? String(v.v) : ratToText(v.q);
}
function lineKey(pl) {
  if (pl.kind === 'claims')
    return pl.claims
      .map(
        (c) =>
          `${c.call ? callKey(c.target) : c.target}${c.approx ? '\u2248' : '='}${valueKey(c.value)}`,
      )
      .sort()
      .join(';');
  const e = (x) =>
    x.k === 'list'
      ? `[${x.items.map(e).join(',')}]`
      : x.k === 'num'
        ? ratToText(x.q)
        : x.k === 'none'
          ? 'None'
          : x.k === 'bool'
            ? String(x.v)
            : x.k === 'var'
              ? x.name
              : x.k === 'call'
                ? callKey(x.atom)
                : x.k === 'neg'
                  ? `-(${e(x.e)})`
                  : `(${e(x.l)}${x.op}${e(x.r)})`;
  if (pl.kind === 'calc') return `calc:${e(pl.e)}=${valueKey(pl.value)}`;
  return `${e(pl.l)}${pl.op}${e(pl.r)}`;
}
function kprogLine(text) {
  return { dis: [{ sides: [{ k: 's', n: text }] }] };
}
var textOf = (A) =>
  A.join(' ')
    .replace(/\( /g, '(')
    .replace(/ \)/g, ')')
    .replace(/\[ /g, '[')
    .replace(/ \]/g, ']')
    .replace(/ ,/g, ',');
function programOf(model) {
  const p = model.kernel?.program;
  if (!p) throw new Error('Feuille Python sans programme');
  return p;
}
function parseDraw(t) {
  const s = t.trim();
  if (s === 'True' || s === 'False') return pyBool(s === 'True');
  if (/^[−-]?\d+$/.test(s)) return pyInt(BigInt(s.replace('\u2212', '-')));
  if (/^[−-]?\d+,\d+$/.test(s)) {
    const q = parseDecimal(s.replace('-', '\u2212'));
    return q ? pyFloat(q) : null;
  }
  return null;
}
function drawsOf(model) {
  const d = model.kernel?.program?.draws;
  if (!d) return void 0;
  return d.map((t) => {
    const v = parseDraw(t);
    if (!v) throw new Error(`Tirage illisible : \xAB ${t} \xBB`);
    return v;
  });
}
function createKProgState(model) {
  const spec = model.kernel;
  const prog = programOf(model);
  if (spec.goal.kind === 'complete') return createCompleteState(model);
  const draws = drawsOf(model);
  const trace = runProgram(prog.code, { ...(prog.call ? { call: prog.call } : {}), draws });
  if (!trace.ok) throw new Error(`Programme : ${trace.error.message} (ligne ${trace.error.line})`);
  const points = trace.points;
  const ends = points.flatMap((p, i) => (p.end ? [i] : []));
  const names = /* @__PURE__ */ new Set();
  points.forEach((p) => Object.keys(p.vars).forEach((n) => names.add(n)));
  const funcs = new Set(
    [...prog.code.matchAll(/^\s*def\s+([A-Za-z_À-ɏ][\wÀ-ɏ]*)/gm)].map((m) => m[1]),
  );
  const answerLine = readLine(kprogLineAtoms(spec.answer));
  if (answerLine.kind !== 'claims')
    throw new Error('La r\xE9ponse s\u2019\xE9crit \xAB variable = valeur \xBB.');
  const loopTours = /* @__PURE__ */ new Map();
  points.forEach((p) => {
    if (p.unit === 'iteration' && p.loop) loopTours.set(p.loop, (loopTours.get(p.loop) ?? 0) + 1);
  });
  const ks = {
    mode: 'trace',
    spec,
    code: prog.code,
    call: prog.call ?? null,
    trace,
    points,
    last: points.length - 1,
    ends,
    watch: prog.watch ?? defaultWatch(points),
    focusKey: trace.focus ? callKey(trace.focus.atom) : null,
    cursor: 0,
    lines: [],
    condsDone: /* @__PURE__ */ new Set(),
    callsDone: /* @__PURE__ */ new Set(),
    evalsDone: /* @__PURE__ */ new Set(),
    visited: [0],
    loopTours,
    draws,
    complete: null,
    atLast: /* @__PURE__ */ new Set(),
    concluded: false,
    answer: answerLine.claims,
    traps: [],
    path: spec.path ?? [],
    known: null,
    callCache: /* @__PURE__ */ new Map(),
    funcs,
    names,
  };
  ks.traps = (model.traps ?? []).flatMap((t) => {
    try {
      return [
        {
          key: lineKey(readLine(kprogLineAtoms(t.line))),
          title: t.title,
          why: t.why,
          line: kprogLine(t.line),
        },
      ];
    } catch {
      return [];
    }
  });
  const extra = [
    spec.answer,
    ...ks.path,
    ...(model.traps ?? []).map((t) => t.line),
    ...(model.choices ?? []).flatMap((c) => (c.line ? [c.line] : [])),
  ];
  ks.known = extra.flatMap((t) => {
    try {
      return [kprogLineAtoms(t)];
    } catch {
      return [];
    }
  });
  return ks;
}
function defaultWatch(points) {
  const out = [];
  const scalar = (v) => !!v && (v.t === 'int' || v.t === 'float' || v.t === 'bool');
  points.forEach((p, i) => {
    Object.keys(p.vars).forEach((n) => {
      if (out.includes(n) || !scalar(p.vars[n])) return;
      const prev = i ? points[i - 1].vars[n] : void 0;
      const changed = !prev || formatValue(prev) !== formatValue(p.vars[n]);
      if (i === 0 && points[0].kind === 'start') return;
      if (changed) out.push(n);
    });
  });
  return out;
}
function matchesWritten(v, w) {
  if (w.k === 'list')
    return (
      (v.t === 'list' || v.t === 'tuple') &&
      v.items.length === w.items.length &&
      v.items.every((x, i) => matchesWritten(x, w.items[i]))
    );
  if (w.k === 'none') return v.t === 'none';
  if (w.k === 'bool') return v.t === 'bool' && v.v === w.v;
  if (v.t !== 'int' && v.t !== 'float') return false;
  return eq(numOf(v), w.q);
}
function valueMatches(v, c) {
  if (!v) return false;
  if (c.value.k === 'list') return matchesWritten(v, c.value);
  if (c.value.k === 'none') return v.t === 'none';
  if (c.value.k === 'bool') return v.t === 'bool' && v.v === c.value.v;
  if (v.t !== 'int' && v.t !== 'float') return false;
  const q = numOf(v);
  if (!c.approx) return eq(q, c.value.q);
  return isRoundingOf(fromRat(q), c.value.q, c.places);
}
function claimHoldsAt(ks, c, k) {
  const p = ks.points[k];
  if (c.call) return p.kind === 'return' && valueMatches(p.ret, c);
  return valueMatches(p.vars[c.target], c);
}
var holdsAt = (ks, cs, k) => cs.every((c) => claimHoldsAt(ks, c, k));
function nextEnd(ks, c) {
  return ks.ends.find((e) => e > c) ?? Infinity;
}
function prevEnd(ks, c) {
  let out = 0;
  ks.ends.forEach((e) => {
    if (e < c) out = e;
  });
  return out;
}
function callValue(ks, atom) {
  const key = callKey(atom);
  if (ks.callCache.has(key)) return ks.callCache.get(key);
  const m = CALL_RE.exec(atom);
  const inner = m[2];
  const py = `${m[1]}(${inner.replace(/−/g, '-').replace(/(\d),(\d)/g, '$1.$2')})`;
  const v = ks.funcs.has(m[1])
    ? evalCall(ks.code, py, void 0, ks.draws ? { draws: ks.draws } : {})
    : null;
  ks.callCache.set(key, v);
  return v;
}
function exprValue(ks, e, vars) {
  switch (e.k) {
    case 'list':
      return null;
    case 'num':
      return e.q;
    case 'none':
      return null;
    case 'bool':
      return e.v;
    case 'var': {
      const v = vars[e.name];
      if (!v) return null;
      if (v.t === 'bool') return v.v;
      return numOf(v);
    }
    case 'call': {
      const v =
        callKey(e.atom) === ks.focusKey ? (ks.trace.focus?.value ?? null) : callValue(ks, e.atom);
      if (!v) return null;
      if (v.t === 'bool') return v.v;
      return numOf(v);
    }
    case 'neg': {
      const v = exprValue(ks, e.e, vars);
      return v !== null && typeof v !== 'boolean' ? neg(v) : null;
    }
    case 'bin': {
      const l = exprValue(ks, e.l, vars);
      const r = exprValue(ks, e.r, vars);
      if (l === null || r === null || typeof l === 'boolean' || typeof r === 'boolean') return null;
      return arithOp(e.op, l, r);
    }
  }
}
var PY_CMP = {
  '<': '<',
  '>': '>',
  '<=': '\u2264',
  '>=': '\u2265',
  '!=': '\u2260',
  '==': '=',
};
var NEG = {
  '<': '\u2265',
  '>': '\u2264',
  '\u2264': '>',
  '\u2265': '<',
  '\u2260': '=',
  '=': '\u2260',
};
var FLIP = {
  '<': '>',
  '>': '<',
  '\u2264': '\u2265',
  '\u2265': '\u2264',
  '\u2260': '\u2260',
  '=': '=',
};
function cmpHolds(op, a, b) {
  if (typeof a === 'boolean' || typeof b === 'boolean')
    return op === '=' ? a === b : op === '\u2260' ? a !== b : false;
  const c = cmp(a, b);
  return op === '<'
    ? c < 0
    : op === '>'
      ? c > 0
      : op === '\u2264'
        ? c <= 0
        : op === '\u2265'
          ? c >= 0
          : op === '\u2260'
            ? c !== 0
            : c === 0;
}
var sameValue = (a, v) => {
  if (a === null) return false;
  if (typeof a === 'boolean') return v.t === 'bool' && v.v === a;
  const q = numOf(v);
  return !!q && v.t !== 'bool' && eq(a, q);
};
function saysOutcome(e, op, l, r) {
  if (!e.cmp) return false;
  const pop = PY_CMP[e.cmp.op];
  if (!pop) return false;
  const said = e.result ? pop : NEG[pop];
  if (sameValue(l, e.cmp.l) && sameValue(r, e.cmp.r) && op === said) return true;
  return sameValue(l, e.cmp.r) && sameValue(r, e.cmp.l) && op === FLIP[said];
}
function knownAtoms(ks) {
  return ks.known ?? [];
}
function strictPrefixOfKnown(ks, A) {
  return knownAtoms(ks).some((k) => k.length > A.length && A.every((a, i) => k[i] === a));
}
function kprogJudge(ks, chips, opts) {
  const A = chips.flatMap((c) => c.atoms);
  if (!A.length) return { kind: 'empty', atoms: A, badChip: -1 };
  if (ks.mode === 'complete') return judgeComplete(ks, A, opts);
  const prefix = strictPrefixOfKnown(ks, A);
  let pl;
  try {
    pl = readLine(A);
  } catch (e) {
    if (e instanceof Incomplete || prefix)
      return { kind: prefix ? 'building' : 'open', atoms: A, complete: false };
    return {
      kind: 'syntax',
      atoms: A,
      title: '\xC7a commence mal',
      message: e instanceof Error ? e.message : String(e),
      badChip: chips.length - 1,
    };
  }
  const v = evaluate(ks, pl, A);
  if (prefix && !opts?.verify) {
    if (v.kind === 'step') return { ...v, kind: 'ready' };
    return { kind: 'building', atoms: A, complete: true };
  }
  if (!opts?.verify && (v.kind === 'unjustified' || v.kind === 'false'))
    return { kind: 'pending', atoms: A, complete: true };
  return v;
}
var valueText = (v) =>
  v.k === 'list'
    ? `[${v.items.map(valueText).join(', ')}]`
    : v.k === 'none'
      ? 'None'
      : v.k === 'bool'
        ? v.v
          ? 'True'
          : 'False'
        : formatValue({ t: 'float', v: v.q }).replace(/^(-?\d+),0$/, '$1');
var claimText = (c) => `${c.target} ${c.approx ? '\u2248' : '='} ${valueText(c.value)}`;
var claimsText = (cs) => cs.map(claimText).join(' ; ');
var UNIT_LABEL = {
  block: {
    id: PYTHON_STEP_IDS.block,
    label: 'Ex\xE9cuter les instructions',
    why: (s) => `Les instructions s\u2019ex\xE9cutent dans l\u2019ordre : ${s}.`,
  },
  iteration: {
    id: PYTHON_STEP_IDS.iteration,
    label: 'Un tour de boucle',
    why: (s) => `Apr\xE8s ce tour de boucle : ${s}.`,
  },
  branch: {
    id: PYTHON_STEP_IDS.branch,
    label: 'Ex\xE9cuter le bloc',
    why: (s) => `Le test choisit le bloc \xE0 ex\xE9cuter : ${s}.`,
  },
  return: {
    id: PYTHON_STEP_IDS.return,
    label: 'La valeur renvoy\xE9e',
    why: (s) => `La fonction renvoie sa valeur : ${s}.`,
  },
};
function evaluate(ks, pl, A) {
  const text = textOf(A);
  const line = kprogLine(text);
  const key = lineKey(pl);
  const base = { atoms: A, line };
  if (pl.kind === 'cmp') return evaluateCmp(ks, pl, key, base);
  if (pl.kind === 'calc') return evaluateCalc(ks, pl, key, base);
  for (const c of pl.claims) {
    if (c.call) {
      const m = CALL_RE.exec(c.target);
      if (callKey(c.target) !== ks.focusKey && !ks.funcs.has(m[1]))
        return {
          kind: 'false',
          ...base,
          title: 'Fonction inconnue',
          message: `Le programme n\u2019a pas de fonction \xAB ${m[1]} \xBB.`,
        };
    } else if (!ks.names.has(c.target))
      return {
        kind: 'false',
        ...base,
        title: 'Variable inconnue',
        message: `Le programme n\u2019a pas de variable \xAB ${c.target} \xBB.`,
      };
  }
  const calls = pl.claims.filter((c) => c.call && callKey(c.target) !== ks.focusKey);
  if (calls.length && calls.length < pl.claims.length)
    return {
      kind: 'syntax',
      ...base,
      title: 'Une ligne pour l\u2019appel',
      message: '\xC9cris le calcul d\u2019un appel de fonction sur sa propre ligne.',
      badChip: -1,
    };
  if (calls.length) return evaluateCalls(ks, calls, key, base);
  return evaluateState(ks, pl.claims, key, base);
}
function trapOrFalse(ks, key, base, title, message) {
  const trap = ks.traps.find((t) => t.key === key);
  if (trap)
    return {
      kind: 'trap',
      ...base,
      title: 'Pi\xE8ge : ' + trap.title.charAt(0).toLowerCase() + trap.title.slice(1),
      message: trap.why,
      trap: { line: trap.line, title: trap.title, why: trap.why },
      badChip: -1,
    };
  return { kind: 'false', ...base, title, message };
}
function evaluateState(ks, claims, key, base) {
  const c = ks.cursor;
  const targets = claims.map((x) => (x.call ? callKey(x.target) : x.target));
  if (holdsAt(ks, claims, c)) {
    if (claims.length === 1 && !claims[0].call && !claims[0].approx) {
      const cv0 = claims[0].value;
      const cv =
        cv0.k === 'none' || cv0.k === 'list'
          ? null
          : evaluateCmpLike(
              ks,
              { k: 'var', name: claims[0].target },
              '=',
              cv0.k === 'bool' ? { k: 'bool', v: cv0.v } : { k: 'num', q: cv0.q },
              key,
              base,
            );
      if (cv) return cv;
    }
    if (c === ks.last && coversAnswer(ks, claims)) {
      if (ks.concluded)
        return {
          kind: 'useless',
          ...base,
          title: 'Tu as d\xE9j\xE0 conclu',
          message: 'Le programme est fini et ta r\xE9ponse est \xE9crite.',
          pmove: { key },
        };
      return {
        kind: 'step',
        ...base,
        final: true,
        hora: 1,
        rule: {
          id: PYTHON_STEP_IDS.conclude,
          card: CARD,
          label: 'Conclure',
          hora: 1,
          why: `Le programme est fini : ${claimsText(claims)}.`,
        },
        pmove: { key, conclude: true, to: c, targets },
      };
    }
    if (ks.answer.length && c < ks.last && sameTargets(ks, claims) && holdsAt(ks, claims, ks.last))
      return {
        kind: 'useless',
        ...base,
        title: 'Pas encore fini',
        message:
          'C\u2019est vrai pour l\u2019instant, mais le programme continue : trace la suite.',
        pmove: { key },
      };
    return {
      kind: 'useless',
      ...base,
      title: 'Rien de nouveau',
      message:
        'C\u2019est d\xE9j\xE0 l\u2019\xE9tat du programme \xE0 ta derni\xE8re ligne : \xE9cris ce qui change ensuite.',
      pmove: { key },
    };
  }
  let k = -1;
  for (let j = c + 1; j < ks.points.length; j++)
    if (holdsAt(ks, claims, j)) {
      k = j;
      break;
    }
  if (k < 0) {
    if (claims.some((x) => !x.approx && x.value.k === 'num') && approxWouldHold(ks, claims))
      return {
        kind: 'false',
        ...base,
        title: 'Valeur approch\xE9e',
        message:
          'Le programme calcule une valeur avec plus de d\xE9cimales : \xE9cris \xAB \u2248 \xBB pour une valeur arrondie.',
      };
    for (let j = 0; j < c; j++)
      if (holdsAt(ks, claims, j))
        return trapOrFalse(
          ks,
          key,
          base,
          'C\u2019\xE9tait avant',
          'Ces valeurs, c\u2019\xE9tait plus t\xF4t dans le programme. \xC9cris l\u2019\xE9tat qui suit ta derni\xE8re ligne.',
        );
    const never = claims.find(
      (x) => !ks.points.slice(c + 1).some((_, i) => claimHoldsAt(ks, x, c + 1 + i)),
    );
    return trapOrFalse(
      ks,
      key,
      base,
      'Ce n\u2019est pas ce que fait le programme',
      never
        ? never.call
          ? `${never.target} ne renvoie pas ${claimText(never).split(/ [=≈] /)[1]}.`
          : `Apr\xE8s ta derni\xE8re ligne, ${never.target} ne vaut jamais ${claimText(never).split(/ [=≈] /)[1]}.`
        : 'Ces valeurs ne sont jamais vraies en m\xEAme temps : relis l\u2019ordre des instructions.',
    );
  }
  const end = nextEnd(ks, c);
  if (k < end && end !== Infinity && holdsAt(ks, claims, end) && writesChanges(ks, claims, c, end))
    k = end;
  let jump = 0;
  if (k > end) {
    const p = ks.points[end];
    const j = jumpCheck(ks, claims, c, end, k);
    if (j.ok) jump = j.tours;
    else
      return {
        kind: 'unjustified',
        ...base,
        title:
          j.title ??
          (p.unit === 'iteration' ? 'Un tour \xE0 la fois' : 'Une \xE9tape \xE0 la fois'),
        message:
          j.message ??
          (p.unit === 'iteration'
            ? 'Ta ligne sera juste plus tard : \xE9cris d\u2019abord l\u2019\xE9tat \xE0 la fin du tour suivant.'
            : 'Ta ligne sera juste plus tard : \xE9cris d\u2019abord ce que fait l\u2019\xE9tape suivante du programme.'),
      };
  }
  const fromEnd = ks.points[c].end;
  const isEnd = k === end || jump > 0;
  const unit = isEnd ? (ks.points[k].unit ?? 'block') : null;
  const hora = isEnd && fromEnd ? 2 : 1;
  const u = jump
    ? {
        id: PYTHON_STEP_IDS.jump,
        label: 'Sauter des tours',
        why: (t) => `Tu avances de ${jump} tours d\u2019un coup : \xE0 la fin de ce tour, ${t}.`,
      }
    : unit
      ? UNIT_LABEL[unit]
      : null;
  const covers = k === ks.last && coversAnswer(ks, claims);
  const exitPending =
    k === ks.last &&
    ks.trace.conds.some((e, i) => e.after === ks.last && e.loop && !ks.condsDone.has(i));
  const final = covers && !exitPending && !ks.concluded;
  const why =
    (u ? u.why(claimsText(claims)) : `Une instruction ex\xE9cut\xE9e : ${claimsText(claims)}.`) +
    (final ? ' Le programme est fini.' : '');
  return {
    kind: 'step',
    ...base,
    hora,
    final,
    rule: u
      ? { id: u.id, card: CARD, label: u.label, hora, why }
      : { id: PYTHON_STEP_IDS.assign, card: CARD, label: 'Une affectation', hora, why },
    pmove: { key, to: k, targets, ...(final ? { conclude: true } : {}) },
  };
}
function jumpCheck(ks, claims, c, end, k) {
  const pe = ks.points[end];
  const loop = pe.unit === 'iteration' ? pe.loop : void 0;
  if (!loop || (ks.loopTours.get(loop) ?? 0) < PYTHON_JUMP_MIN_TOURS) return { ok: false };
  const e = ks.ends.find((x) => x >= k) ?? -1;
  const pk = e >= 0 ? ks.points[e] : null;
  if (!pk || pk.unit !== 'iteration' || pk.loop !== loop) return { ok: false };
  const written = ks.visited.filter((v) => {
    const p = ks.points[v];
    return p.unit === 'iteration' && p.loop === loop;
  }).length;
  if (written < JUMP_AFTER_TOURS)
    return {
      ok: false,
      title: 'Un tour \xE0 la fois',
      message:
        'La boucle est longue : \xE9cris d\u2019abord deux tours en entier, ensuite tu pourras sauter des tours.',
    };
  if (e !== k || !holdsAt(ks, claims, e))
    return {
      ok: false,
      title: '\xC0 la fin d\u2019un tour',
      message:
        'Pour sauter des tours, \xE9cris l\u2019\xE9tat \xE0 la FIN d\u2019un tour, pas au milieu.',
    };
  if (!writesChanges(ks, claims, c, e))
    return {
      ok: false,
      title: 'L\u2019\xE9tat complet',
      message:
        'Pour sauter des tours, \xE9cris toutes les variables qui changent pendant la boucle, s\xE9par\xE9es par \xAB ; \xBB.',
    };
  const tours = ks.points.filter(
    (p, i) => i > c && i <= e && p.unit === 'iteration' && p.loop === loop,
  ).length;
  return { ok: true, tours };
}
function writesChanges(ks, claims, a, b) {
  const written = new Set(claims.filter((x) => !x.call).map((x) => x.target));
  const va = ks.points[a].vars;
  const vb = ks.points[b].vars;
  const key = (v) => (v ? formatValue(v, true) : '\u2205');
  return ks.watch.every((n) => key(va[n]) === key(vb[n]) || written.has(n));
}
function sameTargets(ks, claims) {
  const t = new Set(claims.map((c) => (c.call ? callKey(c.target) : c.target)));
  return ks.answer.every((a) => t.has(a.call ? callKey(a.target) : a.target));
}
function coversAnswer(ks, claims) {
  return sameTargets(ks, claims) && holdsAt(ks, claims, ks.last) && holdsAt(ks, ks.answer, ks.last);
}
function approxWouldHold(ks, claims) {
  const loose = claims.map((x) =>
    !x.approx && x.value.k === 'num' ? { ...x, approx: true, places: decimals(x.value.q) } : x,
  );
  for (let j = ks.cursor + 1; j < ks.points.length; j++) if (holdsAt(ks, loose, j)) return true;
  return false;
}
function decimals(q) {
  let n = 0;
  let x = q;
  while (!isInteger(x) && n < 30) {
    x = mul(x, rat(10));
    n++;
  }
  return n;
}
function inWindow(ks, after) {
  const c = ks.cursor;
  return after >= prevEnd(ks, c) && after < nextEnd(ks, c);
}
function exprNames(e, out = /* @__PURE__ */ new Set()) {
  if (e.k === 'var') out.add(e.name);
  if (e.k === 'call') out.add(CALL_RE.exec(e.atom)[1]);
  if (e.k === 'neg') exprNames(e.e, out);
  if (e.k === 'bin') {
    exprNames(e.l, out);
    exprNames(e.r, out);
  }
  return out;
}
function evaluateCmpLike(ks, l, op, r, key, base) {
  const conds = ks.trace.conds;
  const written = exprNames(r, exprNames(l));
  for (let i = 0; i < conds.length; i++) {
    const e = conds[i];
    if (!inWindow(ks, e.after)) continue;
    const inTest = new Set(e.text.match(/[A-Za-z_\u00C0-\u024F][\w\u00C0-\u024F]*/g) ?? []);
    if ([...written].some((n) => !inTest.has(n))) continue;
    const vars = ks.points[Math.max(0, e.after)].vars;
    const lv = exprValue(ks, l, vars);
    const rv = exprValue(ks, r, vars);
    if (!saysOutcome(e, op, lv, rv)) continue;
    if (ks.condsDone.has(i))
      return {
        kind: 'useless',
        ...base,
        title: 'D\xE9j\xE0 test\xE9',
        message: 'Tu as d\xE9j\xE0 \xE9crit ce test.',
        pmove: { key },
      };
    const verdict = e.result ? 'vrai' : 'faux';
    const then = e.loop
      ? e.result
        ? 'la boucle continue'
        : 'la boucle s\u2019arr\xEAte'
      : e.result
        ? 'on ex\xE9cute le bloc du if'
        : 'on passe \xE0 la suite (else)';
    const exit = e.loop && !e.result && e.after === ks.last;
    const final =
      exit &&
      !ks.concluded &&
      ks.answer.every((a) => ks.atLast.has(a.call ? callKey(a.target) : a.target)) &&
      holdsAt(ks, ks.answer, ks.last);
    const why =
      `\xAB ${e.text} \xBB est ${verdict} : ${then}.` + (final ? ' Le programme est fini.' : '');
    return {
      kind: 'step',
      ...base,
      hora: 1,
      final,
      rule: {
        id: PYTHON_STEP_IDS.condition,
        card: CARD,
        label: 'Tester la condition',
        hora: 1,
        why,
      },
      pmove: { key, conds: [i], ...(final ? { conclude: true } : {}) },
    };
  }
  return null;
}
function evaluateCmp(ks, pl, key, base) {
  const names = /* @__PURE__ */ new Set();
  const walk = (e) => {
    if (e.k === 'var') names.add(e.name);
    if (e.k === 'neg') walk(e.e);
    if (e.k === 'bin') {
      walk(e.l);
      walk(e.r);
    }
  };
  walk(pl.l);
  walk(pl.r);
  const unknown = [...names].find((n) => !ks.names.has(n));
  if (unknown)
    return {
      kind: 'false',
      ...base,
      title: 'Variable inconnue',
      message: `Le programme n\u2019a pas de variable \xAB ${unknown} \xBB.`,
    };
  const hit = evaluateCmpLike(ks, pl.l, pl.op, pl.r, key, base);
  if (hit) return hit;
  const vars = ks.points[ks.cursor].vars;
  const lv = exprValue(ks, pl.l, vars);
  const rv = exprValue(ks, pl.r, vars);
  if (lv === null || rv === null)
    return {
      kind: 'false',
      ...base,
      title: 'Je ne peux pas comparer',
      message: 'Une des valeurs n\u2019existe pas encore \xE0 ce moment du programme.',
    };
  if (!cmpHolds(pl.op, lv, rv))
    return trapOrFalse(
      ks,
      key,
      base,
      'Comparaison fausse',
      'Avec les valeurs \xE0 ta derni\xE8re ligne, cette comparaison est fausse.',
    );
  return {
    kind: 'useless',
    ...base,
    title: 'Juste, mais \xE0 c\xF4t\xE9',
    message: 'C\u2019est vrai, mais ce n\u2019est pas le test que fait le programme maintenant.',
    pmove: { key },
  };
}
var PY_ARITH = { '+': '+', '\u2212': '-', '\xD7': '*', '\xF7': '/', '%': '%' };
function pexprText(e) {
  switch (e.k) {
    case 'list':
      return `[${e.items.map(pexprText).join(', ')}]`;
    case 'num':
      return formatValue({ t: 'float', v: e.q }).replace(/^(−?\d+),0$/, '$1');
    case 'none':
      return 'None';
    case 'bool':
      return e.v ? 'True' : 'False';
    case 'var':
      return e.name;
    case 'call':
      return e.atom;
    case 'neg':
      return `\u2212${pexprText(e.e)}`;
    case 'bin':
      return `${pexprText(e.l)} ${e.op} ${pexprText(e.r)}`;
  }
}
function evaluateCalc(ks, pl, key, base) {
  const written = exprNames(pl.e);
  const unknown = [...written].find((n) => !ks.names.has(n) && !ks.funcs.has(n));
  if (unknown)
    return {
      kind: 'false',
      ...base,
      title: 'Variable inconnue',
      message: `Le programme n\u2019a pas de variable \xAB ${unknown} \xBB.`,
    };
  const op = PY_ARITH[pl.e.op];
  const said = pl.value;
  const lineText = pexprText(pl.e);
  const evals = ks.trace.evals;
  for (let i = 0; i < evals.length; i++) {
    const e = evals[i];
    if (!inWindow(ks, e.after)) continue;
    if (e.op !== op && !(op === '/' && e.op === '//')) continue;
    const inText = new Set(e.text.match(/[A-Za-z_\u00C0-\u024F][\w\u00C0-\u024F]*/g) ?? []);
    if ([...written].some((n) => !inText.has(n))) continue;
    const vars2 = ks.points[Math.max(0, e.after)].vars;
    if (
      !sameValue(exprValue(ks, pl.e.l, vars2), e.l) ||
      !sameValue(exprValue(ks, pl.e.r, vars2), e.r)
    )
      continue;
    const ok =
      said.k === 'num'
        ? sameValue(said.q, e.v)
        : said.k === 'bool'
          ? sameValue(said.v, e.v)
          : false;
    if (!ok)
      return trapOrFalse(ks, key, base, 'Recalcule', `${lineText} ne vaut pas ${valueText(said)}.`);
    if (ks.evalsDone.has(i))
      return {
        kind: 'useless',
        ...base,
        title: 'D\xE9j\xE0 calcul\xE9',
        message: 'Tu as d\xE9j\xE0 \xE9crit ce calcul.',
        pmove: { key },
      };
    return {
      kind: 'step',
      ...base,
      hora: 1,
      rule: {
        id: PYTHON_STEP_IDS.eval,
        card: CARD,
        label: 'Calculer',
        hora: 1,
        why: `Le programme calcule ${e.text} : ${lineText} = ${valueText(said)}.`,
      },
      pmove: { key, evals: [i] },
    };
  }
  const vars = ks.points[ks.cursor].vars;
  const v = exprValue(ks, pl.e, vars);
  if (v === null || typeof v === 'boolean' || said.k !== 'num')
    return {
      kind: 'false',
      ...base,
      title: 'Je ne peux pas calculer',
      message: 'Une des valeurs n\u2019existe pas encore \xE0 ce moment du programme.',
    };
  if (!eq(v, said.q))
    return trapOrFalse(ks, key, base, 'Calcul faux', `${lineText} ne vaut pas ${valueText(said)}.`);
  return {
    kind: 'useless',
    ...base,
    title: 'Juste, mais \xE0 c\xF4t\xE9',
    message: 'C\u2019est juste, mais le programme ne fait pas ce calcul maintenant.',
    pmove: { key },
  };
}
function evaluateCalls(ks, calls, key, base) {
  for (const c of calls) {
    const v = callValue(ks, c.target);
    if (!v)
      return {
        kind: 'false',
        ...base,
        title: 'Appel impossible',
        message: `Je ne sais pas calculer ${c.target} avec ce programme.`,
      };
    if (!valueMatches(v, c))
      return trapOrFalse(
        ks,
        key,
        base,
        'Recalcule',
        `${c.target} ne vaut pas ${claimText(c).split(/ [=≈] /)[1]}.`,
      );
  }
  const fresh = calls.filter(
    (c) =>
      !ks.callsDone.has(callKey(c.target)) &&
      ks.trace.calls.some((e) => callKey(e.atom) === callKey(c.target) && inWindow(ks, e.after)),
  );
  if (!fresh.length)
    return calls.every((c) => ks.callsDone.has(callKey(c.target)))
      ? {
          kind: 'useless',
          ...base,
          title: 'D\xE9j\xE0 calcul\xE9',
          message: 'Tu as d\xE9j\xE0 \xE9crit ce calcul.',
          pmove: { key },
        }
      : {
          kind: 'useless',
          ...base,
          title: 'Juste, mais \xE0 c\xF4t\xE9',
          message: 'C\u2019est juste, mais le programme ne fait pas ce calcul maintenant.',
          pmove: { key },
        };
  const hora = fresh.length;
  return {
    kind: 'step',
    ...base,
    hora,
    rule: {
      id: PYTHON_STEP_IDS.call,
      card: CARD,
      label: `Calculer ${fresh.map((c) => c.target).join(' et ')}`,
      hora,
      why: `Le programme calcule ${fresh.map((c) => c.target).join(' et ')} : ${claimsText(fresh)}.`,
    },
    pmove: { key, calls: fresh.map((c) => callKey(c.target)) },
  };
}
function kprogCommit(ks, v) {
  const m = v.pmove;
  if (!m || (v.kind !== 'step' && v.kind !== 'ready' && v.kind !== 'useless')) return;
  ks.lines.push({ key: m.key, text: v.line ? v.line.dis[0].sides[0].n : '' });
  if (v.kind === 'useless') return;
  if (m.to !== void 0) {
    ks.cursor = m.to;
    ks.visited.push(m.to);
    if (m.to === ks.last) (m.targets ?? []).forEach((t) => ks.atLast.add(t));
  }
  (m.conds ?? []).forEach((i) => ks.condsDone.add(i));
  (m.calls ?? []).forEach((c) => ks.callsDone.add(c));
  (m.evals ?? []).forEach((i) => ks.evalsDone.add(i));
  if (m.conclude) ks.concluded = true;
}
function kprogGoalReached(ks) {
  return ks.concluded;
}
function readText(text) {
  try {
    return readLine(kprogLineAtoms(text));
  } catch {
    return null;
  }
}
function kprogEstablished(ks, text) {
  if (ks.mode === 'complete') {
    const k = codeKeyOf(text);
    return k !== null && ks.lines.some((l) => l.key === k);
  }
  const pl = readText(text);
  if (!pl) return false;
  const key = lineKey(pl);
  return ks.lines.some((l) => l.key === key);
}
function kprogHolds(ks, text) {
  if (ks.mode === 'complete') return completePasses(ks, text);
  const pl = readText(text);
  return !!pl && pl.kind === 'claims' && holdsAt(ks, pl.claims, ks.last);
}
function kprogEverHolds(ks, text) {
  if (ks.mode === 'complete') return completePasses(ks, text);
  const pl = readText(text);
  if (!pl || pl.kind !== 'claims') return false;
  return ks.points.some((_, k) => holdsAt(ks, pl.claims, k));
}
function kprogSameAsAnswer(ks, text) {
  if (ks.mode === 'complete') return completePasses(ks, text);
  const pl = readText(text);
  return (
    !!pl && pl.kind === 'claims' && sameTargets(ks, pl.claims) && holdsAt(ks, pl.claims, ks.last)
  );
}
function kprogIsAnswer(ks, text) {
  return ks.concluded && kprogSameAsAnswer(ks, text);
}
var chipsOf = (atoms) => atoms.map((a) => ({ atoms: [a], text: a }));
function kprogNextMove(ks) {
  if (ks.concluded) return null;
  for (const text of [...ks.path, ks.spec.answer]) {
    let atoms;
    try {
      atoms = ks.mode === 'complete' ? kprogCodeAtoms(text) : kprogLineAtoms(text);
    } catch {
      continue;
    }
    const v = kprogJudge(ks, chipsOf(atoms), { verify: true });
    if (v.kind === 'step')
      return { line: kprogLine(text), text, atoms, label: v.rule?.label ?? '' };
  }
  return null;
}
function kprogSolvePath(model) {
  const ks = createKProgState(model);
  const lines = ks.path.map((text) => {
    const atoms = ks.mode === 'complete' ? kprogCodeAtoms(text) : kprogLineAtoms(text);
    const v = kprogJudge(ks, chipsOf(atoms), { verify: true });
    if (v.kind === 'step') kprogCommit(ks, v);
    return { text, line: kprogLine(text), atoms, v };
  });
  return { lines, reached: kprogGoalReached(ks) };
}
function kprogPaletteParts(model) {
  try {
    const ks = createKProgState(model);
    if (ks.mode === 'complete') return { names: [], calls: [] };
    const calls = /* @__PURE__ */ new Set();
    if (ks.trace.focus) calls.add(ks.trace.focus.atom);
    [ks.spec.answer, ...ks.path, ...(model.traps ?? []).map((t) => t.line)].forEach((t) => {
      try {
        kprogLineAtoms(t).forEach((a) => {
          if (CALL_RE.test(a)) calls.add(a);
        });
      } catch {
        // ligne illisible : ignorée
      }
    });
    return { names: ks.watch, calls: [...calls] };
  } catch {
    return { names: [], calls: [] };
  }
}
var BLANK_LINE_RE = /^(\s*)_{3,}\s*$/;
var CODE_TOKEN =
  /(\d+\.\d+|\d+)|([A-Za-z_À-ɏ][A-Za-z0-9_À-ɏ]*)|("(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*')|(\*\*=|\/\/=|\*\*|\/\/|==|!=|<=|>=|\+=|-=|\*=|\/=|%=|[-+*/%<>=():,[\].])/y;
var PY_KEYWORDS = /* @__PURE__ */ new Set([
  'for',
  'in',
  'while',
  'if',
  'elif',
  'else',
  'return',
  'not',
  'and',
  'or',
  'def',
  'import',
  'from',
  'is',
  'pass',
  'break',
  'continue',
]);
var isOpToken = (t) => /^[-+*/%<>=!]+$/.test(t);
function kprogCodeAtoms(text) {
  const src = text.replace(/−/g, '-').replace(/×/g, '*').replace(/÷/g, '/');
  const out = [];
  let i = 0;
  while (i < src.length) {
    if (/\s/.test(src[i])) {
      i++;
      continue;
    }
    CODE_TOKEN.lastIndex = i;
    const m = CODE_TOKEN.exec(src);
    if (!m) throw new ProgLineError(`\xAB ${src[i]} \xBB ne s\u2019\xE9crit pas en Python ici.`);
    out.push(m[0]);
    i = CODE_TOKEN.lastIndex;
  }
  return out;
}
function codeText(atoms) {
  let out = '';
  atoms.forEach((a, i) => {
    if (i === 0) {
      out = a;
      return;
    }
    const prev = atoms[i - 1];
    const prev2 = atoms[i - 2];
    let space = true;
    if (a === ')' || a === ']' || a === ':' || a === ',' || a === '.') space = false;
    else if (prev === '(' || prev === '[' || prev === '.') space = false;
    else if ((a === '(' || a === '[') && /^[A-Za-z_À-ɏ0-9\])]/.test(prev) && !PY_KEYWORDS.has(prev))
      space = false;
    else if (
      prev === '-' &&
      (prev2 === void 0 ||
        isOpToken(prev2) ||
        prev2 === '(' ||
        prev2 === '[' ||
        prev2 === ',' ||
        PY_KEYWORDS.has(prev2))
    )
      space = false;
    out += (space ? ' ' : '') + a;
  });
  return out;
}
function codeKeyOf(text) {
  try {
    return codeText(kprogCodeAtoms(text));
  } catch {
    return null;
  }
}
function createCompleteState(model) {
  const spec = model.kernel;
  const prog = programOf(model);
  const lines = prog.code.replace(/\s+$/, '').split('\n');
  const blanks = lines.flatMap((l, i) => (BLANK_LINE_RE.test(l) ? [i] : []));
  if (blanks.length !== 1)
    throw new Error('Le programme doit avoir une seule ligne manquante, \xE9crite \xAB ____ \xBB.');
  const blank = blanks[0];
  const checks = (prog.checks ?? []).map((text) => {
    const pl = readLine(kprogLineAtoms(text));
    if (pl.kind !== 'claims') throw new Error(`Test illisible : \xAB ${text} \xBB`);
    return { text, claims: pl.claims };
  });
  if (!checks.length && !prog.output?.length)
    throw new Error('Compl\xE9ter un programme demande des tests (`checks` ou `output`).');
  const draws = drawsOf(model);
  const ks = {
    mode: 'complete',
    spec,
    code: prog.code,
    call: null,
    trace: runProgram(''),
    points: [],
    last: 0,
    ends: [],
    watch: [],
    focusKey: null,
    cursor: 0,
    lines: [],
    condsDone: /* @__PURE__ */ new Set(),
    callsDone: /* @__PURE__ */ new Set(),
    evalsDone: /* @__PURE__ */ new Set(),
    visited: [],
    loopTours: /* @__PURE__ */ new Map(),
    draws,
    complete: {
      lines,
      blank,
      indent: BLANK_LINE_RE.exec(lines[blank])[1],
      checks,
      output: prog.output ?? null,
      cache: /* @__PURE__ */ new Map(),
    },
    atLast: /* @__PURE__ */ new Set(),
    concluded: false,
    answer: [],
    traps: [],
    path: spec.path ?? [],
    known: null,
    callCache: /* @__PURE__ */ new Map(),
    funcs: /* @__PURE__ */ new Set(),
    names: /* @__PURE__ */ new Set(),
  };
  ks.traps = (model.traps ?? []).flatMap((t) => {
    const key = codeKeyOf(t.line);
    return key ? [{ key, title: t.title, why: t.why, line: kprogLine(key) }] : [];
  });
  ks.known = [
    spec.answer,
    ...ks.path,
    ...(model.traps ?? []).map((t) => t.line),
    ...(model.choices ?? []).flatMap((c) => (c.line ? [c.line] : [])),
  ].flatMap((t) => {
    try {
      return [kprogCodeAtoms(t)];
    } catch {
      return [];
    }
  });
  return ks;
}
var pyCallOf = (atom) => {
  const m = CALL_RE.exec(atom);
  return `${m[1]}(${m[2].replace(/−/g, '-').replace(/(\d),(\d)/g, '$1.$2')})`;
};
function runComplete(ks, text) {
  const cs = ks.complete;
  const hit = cs.cache.get(text);
  if (hit) return hit;
  const lines = cs.lines.slice();
  lines[cs.blank] = cs.indent + text;
  const code = lines.join('\n') + '\n';
  const blankNo = cs.blank + 1;
  const fail = (title, message) => ({ ok: false, title, message });
  const crash = (e) =>
    e.code === 'syntax'
      ? fail(
          'Python ne comprend pas',
          e.line === blankNo
            ? `Python ne comprend pas ta ligne : ${e.message}`
            : `Avec ta ligne, le programme est mal \xE9crit (ligne ${e.line}) : ${e.message}`,
        )
      : e.code === 'budget'
        ? fail(
            'Le programme ne s\u2019arr\xEAte pas',
            'Avec ta ligne, le programme ne s\u2019arr\xEAte pas (ou il est beaucoup trop long).',
          )
        : fail(
            'Erreur \xE0 l\u2019ex\xE9cution',
            `Avec ta ligne, le programme s\u2019arr\xEAte sur une erreur (ligne ${e.line}) : ${e.message}`,
          );
  const result = (() => {
    const opts = { trace: false, ...(ks.draws ? { draws: ks.draws } : {}) };
    const mod = runProgram(code, opts);
    if (mod.error) return crash(mod.error);
    if (cs.output) {
      const got = mod.output;
      if (got.length !== cs.output.length || got.some((l, i) => l !== cs.output[i]))
        return fail(
          'Ce n\u2019est pas ce qu\u2019il faut afficher',
          got.length
            ? `Avec ta ligne, le programme affiche \xAB ${got.join(' ')} \xBB au lieu de \xAB ${cs.output.join(' ')} \xBB.`
            : `Avec ta ligne, le programme n\u2019affiche rien : il doit afficher \xAB ${cs.output.join(' ')} \xBB.`,
        );
    }
    for (const chk of cs.checks)
      for (const c of chk.claims) {
        let v;
        if (c.call) {
          const run = runProgram(code, { ...opts, call: pyCallOf(c.target) });
          if (run.error) return crash(run.error);
          v = run.focus?.value ?? null;
        } else v = mod.globals[c.target];
        if (v === void 0 || v === null)
          return fail(
            'Le test ne passe pas',
            `Avec ta ligne, ${c.target} n\u2019existe pas \xE0 la fin du programme.`,
          );
        if (!valueMatches(v, c))
          return fail(
            'Le test ne passe pas',
            `Avec ta ligne, on obtient ${c.target} = ${formatValue(v)}, au lieu de ${valueText(c.value)}.`,
          );
      }
    return { ok: true };
  })();
  cs.cache.set(text, result);
  return result;
}
function completePasses(ks, text) {
  const key = codeKeyOf(text);
  return key !== null && runComplete(ks, key).ok;
}
var checksText = (cs) =>
  [
    ...cs.checks.map((c) => c.text),
    ...(cs.output ? [`affiche \xAB ${cs.output.join(' ')} \xBB`] : []),
  ].join(' ; ');
function judgeComplete(ks, A, opts) {
  let text;
  try {
    text = codeText(A);
  } catch (e) {
    return {
      kind: 'syntax',
      atoms: A,
      title: '\xC7a commence mal',
      message: e instanceof Error ? e.message : String(e),
      badChip: A.length - 1,
    };
  }
  const prefix = strictPrefixOfKnown(ks, A);
  const line = kprogLine(text);
  const base = { atoms: A, line };
  const key = text;
  const r = runComplete(ks, text);
  if (r.ok) {
    if (ks.concluded)
      return {
        kind: 'useless',
        ...base,
        title: 'Tu as d\xE9j\xE0 conclu',
        message: 'Le programme est compl\xE9t\xE9 et les tests passent.',
        pmove: { key },
      };
    const v = {
      kind: 'step',
      ...base,
      final: true,
      hora: 3,
      rule: {
        id: PYTHON_STEP_IDS.complete,
        card: CARD,
        label: 'Compl\xE9ter le programme',
        hora: 3,
        why: `Avec cette ligne, le programme passe les tests : ${checksText(ks.complete)}.`,
      },
      pmove: { key, conclude: true },
    };
    return prefix && !opts?.verify ? { ...v, kind: 'ready' } : v;
  }
  if (prefix && !opts?.verify) return { kind: 'building', atoms: A, complete: true };
  const trap = ks.traps.find((t) => t.key === key);
  if (trap)
    return {
      kind: 'trap',
      ...base,
      title: 'Pi\xE8ge : ' + trap.title.charAt(0).toLowerCase() + trap.title.slice(1),
      message: trap.why,
      trap: { line: trap.line, title: trap.title, why: trap.why },
      badChip: -1,
    };
  if (!opts?.verify)
    return {
      kind: r.title === 'Python ne comprend pas' ? 'open' : 'pending',
      atoms: A,
      complete: r.title !== 'Python ne comprend pas',
    };
  return { kind: 'false', ...base, title: r.title, message: r.message };
}
function kprogCodePaletteParts(model) {
  const spec = model.kernel;
  const code = spec.program?.code ?? '';
  const texts = [
    spec.answer,
    ...(spec.path ?? []),
    ...(model.traps ?? []).map((t) => t.line),
    ...(model.choices ?? []).flatMap((c) => (c.line ? [c.line] : [])),
  ];
  const atoms = texts.flatMap((t) => {
    try {
      return kprogCodeAtoms(t);
    } catch {
      return [];
    }
  });
  const codeNames = (() => {
    try {
      return kprogCodeAtoms(code.replace(/_{3,}/g, ' '));
    } catch {
      return [];
    }
  })().filter((a) => /^[A-Za-z_À-ɏ]/.test(a));
  const uniq = (xs) => [...new Set(xs)];
  const isName = (a) => /^[A-Za-z_À-ɏ][A-Za-z0-9_À-ɏ]*$/.test(a);
  const words = uniq(
    atoms.filter((a) => isName(a) && (PY_KEYWORDS.has(a) || BUILTIN_WORDS.has(a))),
  );
  const names = uniq(
    [...codeNames, ...atoms].filter(
      (a) => isName(a) && !PY_KEYWORDS.has(a) && !BUILTIN_WORDS.has(a) && !words.includes(a),
    ),
  );
  const numbers = uniq(atoms.filter((a) => /^\d/.test(a))).sort((a, b) => Number(a) - Number(b));
  const ops = uniq(atoms.filter((a) => !isName(a) && !/^\d/.test(a) && !/^["']/.test(a)));
  return { words, names, numbers, ops };
}
var BUILTIN_WORDS = /* @__PURE__ */ new Set([
  'range',
  'print',
  'len',
  'abs',
  'min',
  'max',
  'sum',
  'int',
  'float',
  'round',
  'True',
  'False',
  'None',
  'randint',
  'random',
  'append',
]);
var plusCache = /* @__PURE__ */ new WeakMap();
function usesKernelPythonPlus(model) {
  const cached = plusCache.get(model);
  if (cached !== void 0) return cached;
  const out = (() => {
    try {
      const k = model.kernel;
      const p = k?.program;
      if (!k || !p) return false;
      if (k.goal?.kind === 'complete' || p.draws || p.checks || p.output || p.display) return true;
      if (/\b(import\s+random|from\s+random)\b/.test(p.code)) return true;
      if (/^\s*(if|elif|while)\b.*\b(and|or)\b/m.test(p.code)) return true;
      const m = model;
      const texts = [
        k.answer,
        ...(k.path ?? []),
        ...(m.traps ?? []).map((t2) => t2.line ?? ''),
        ...(m.choices ?? []).map((c) => c.line ?? ''),
      ];
      for (const t2 of texts) {
        if (/\bNone\b/.test(t2)) return true;
        const bare = t2.replace(/[A-Za-z_À-ɏ][\wÀ-ɏ]*\s*\([^()]*\)/g, 'F');
        if (bare.includes('%')) return true;
        if (!bare.includes(';')) {
          const eq2 = bare.search(/[=≈]/);
          if (eq2 > 0 && /[+−×÷*/-]/.test(bare.slice(0, eq2))) return true;
        }
      }
      const t = runProgram(p.code, p.call ? { call: p.call } : {});
      if (!t.ok) return false;
      const tours = /* @__PURE__ */ new Map();
      t.points.forEach((pt) => {
        if (pt.unit === 'iteration' && pt.loop) tours.set(pt.loop, (tours.get(pt.loop) ?? 0) + 1);
      });
      return [...tours.values()].some((n) => n >= PYTHON_JUMP_MIN_TOURS);
    } catch {
      return false;
    }
  })();
  plusCache.set(model, out);
  return out;
}
export {
  BLANK_LINE_RE,
  PYTHON_JUMP_MIN_TOURS,
  PYTHON_STEP_IDS,
  ProgLineError,
  codeText,
  createKProgState,
  kprogCodeAtoms,
  kprogCodePaletteParts,
  kprogCommit,
  kprogEstablished,
  kprogEverHolds,
  kprogGoalReached,
  kprogHolds,
  kprogIsAnswer,
  kprogJudge,
  kprogLine,
  kprogLineAtoms,
  kprogNextMove,
  kprogPaletteParts,
  kprogSameAsAnswer,
  kprogSolvePath,
  parseDraw,
  programOf,
  usesKernelPythonPlus,
};
